(function() {
	'use strict';

	angular
		.module('app.gantt-chart', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.activity', {
				url: '/activity/:activityId',
				views: {
					'content@app': {
						templateUrl: 'app/main/gantt-chart/activity/activity.html',
						controller: 'GanttActivityController as vm'
					}
				},
				loginRequired: true
			})
			.state('app.activity.new',{
				url: '/:jobId',
				views: {
					'content@app': {
						templateUrl: 'app/main/gantt-chart/activity/activity.html',
						controller: 'GanttActivityController as vm'
					}
				},
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/gantt-chart/activity');

		// // Navigation
		// msNavigationServiceProvider.saveItem('fuse', {
		// 	title: 'NODE',
		// 	group: true,
		// 	weight: 1
		// });

		// msNavigationServiceProvider.saveItem('fuse.dashboard', {
		// 	title: 'Dashboard',
		// 	icon: 'icon-tile-four',
		// 	state: 'app.dashboard',
		// 	/*stateParams: {
		// 		'param1': 'page'
		// 	 },*/
		// 	translate: 'DASHBOARD.DASHBOARD_NAV',
		// 	weight: 1
		// });
	}
})();

(function ()
{
    'use strict';

    angular.module('app.gantt-chart')
        .controller('GanttChartAddEditDialogController', GanttChartAddEditDialogController);

    /** @ngInject */
    function GanttChartAddEditDialogController($mdDialog, ganttUtils, dialogData, fuseGenerator)
    {
        var vm = this;

        // Data
        vm.chartData = dialogData.chartData;
        vm.dialogType = dialogData.dialogType;

        /// Edit Dialog
        if ( vm.dialogType === 'edit' )
        {
            vm.formView = dialogData.formView;
            vm.row = vm.task = angular.copy(dialogData.formData.model);
        }

        /// Add Dialog
        else if ( vm.dialogType === 'add' )
        {
            vm.row = {
                id      : ganttUtils.randomUuid(),
                name    : '',
                tasks   : [],
                classes : ['', ''],
                sortable: true,
                parent  : ''
            };
            vm.task = {
                id      : ganttUtils.randomUuid(),
                name    : '',
                classes : ['', ''],
                from    : '',
                to      : '',
                progress: ''
            };
            vm.taskRowId = '';
        }

        // Methods
        vm.addNewRow = addNewRow;
        vm.saveRow = saveRow;
        vm.removeRow = removeRow;
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.removeTask = removeTask;
        vm.closeDialog = closeDialog;
        vm.rgba = fuseGenerator.rgba;

        //////////

        /**
         * Add New Row
         */
        function addNewRow()
        {
            vm.chartData.push(vm.row);

            closeDialog();
        }

        /**
         * Save Row
         */
        function saveRow()
        {
            dialogData.formData.model = vm.row;

            closeDialog();
        }

        /**
         * Remove Row
         */
        function removeRow()
        {
            vm.chartData.splice(vm.chartData.indexOf(vm.chartData.getById(vm.row.id)), 1);

            closeDialog();
        }

        /**
         * Add New Task
         */
        function addNewTask()
        {
            vm.chartData.getById(vm.taskRowId).tasks.push(vm.task);

            closeDialog();
        }

        /**
         * Save Task
         */
        function saveTask()
        {
            dialogData.formData.model = vm.task;

            closeDialog();
        }

        /**
         * Remove Task
         */
        function removeTask()
        {
            var taskRow = vm.chartData.getById(dialogData.formData.row.model.id);

            taskRow.tasks.splice(taskRow.tasks.indexOf(taskRow.tasks.getById(vm.task.id)), 1);

            closeDialog();
        }


        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
    }
})();
(function() {
	'use strict';

	angular
		.module('app.gantt-chart')
		.controller('GanttActivityController', GanttActivityController);

	/** @ngInject */
	function GanttActivityController($rootScope, AuthenticationService, DataSyncService, $location, $timeout, $mdDialog, moment, toastr, dialogData) {
		var vm = this;
		vm.formView = dialogData.formView;
		vm.row = vm.task = angular.copy(dialogData.formData.model);
		vm.activityId = vm.task.name;
		vm.currentActivityData = {};
		vm.activeUsers = [];

		DataSyncService.getActiveUsers(function(response){
			vm.activeUsers = response;
		});

		vm.qcImages = [];
		vm.swiperElem;

		if (vm.activityId != 'new'){
			DataSyncService.sync('getActivityData', {
				id: vm.activityId
			}, function(response) {
				if (response.success) {
					vm.currentActivityData = response.data;
					if (vm.currentActivityData.StartDate){
						vm.currentActivityData.StartDate = moment(response.data.StartDate.split('T')[0]).toDate();
					}
					var tm = response.data.StartTime;
					if (tm){
						tm = tm.split(":");
						vm.currentActivityData.StartTime = new Date(moment().hour(tm[0]).minute(tm[1]).second(0).format('M/DD/YY hh:mm A'));
					}else{
						vm.currentActivityData.StartTime = '';
					}
					vm.currentActivityData.DurationMinutes = parseInt(response.data.DurationMinutes);
					vm.currentActivityData.UnitCount = parseInt(response.data.UnitCount);
					for (var i = 0; response.data.QualityControl && i < response.data.QualityControl.length; i++) {
						var title = '';
						var txt = response.data.QualityControl[i].QcActivityNumber;
						for (var z = 0; response.data.QualityControl[i].Images && z < response.data.QualityControl[i].Images.length; z++) {
							vm.qcImages.push({
								'title': title,
								'text': txt,
								'media': {
									'image': {
										'src': response.data.QualityControl[i].Images[z].ImageUrl,
										'alt': txt + ' image ' + z
									}
								}
							});
						}
					}
					if (vm.swiperElem){
						vm.swiperElem.update();
					}
				} else {
					$location.path('/dashboard');
				}
			});
		}else{

		}

		$timeout(function() {
			if (vm.swiperElem){
				vm.swiperElem.update();
			}
		}, 1050);

		vm.initSwiper = function(swiper) {
			vm.swiperElem = swiper;
		};
		vm.onQcClick = function(qcImage, ev) {
			$mdDialog.show({
				controller: QCImageDialogController,
				templateUrl: '/app/main/activity/activity.qcimage.dialog.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					data: qcImage
				}
			});
		};
		vm.saveActivity = function(){
			var saveObject = angular.copy(vm.currentActivityData);
			if (saveObject.StartTime){
				saveObject.StartTime = moment(saveObject.StartTime).hours() + ':' + moment(saveObject.StartTime).minutes();
			}
			if (saveObject.StartDate){
				saveObject.StartDate = moment(saveObject.StartDate).add(moment().utcOffset()).toJSON();
			}
			DataSyncService.sync('saveActivity',saveObject,function(response){
				if (response.success){
					if (vm.activityId === 'new'){
						toastr.success('Activity Created!','Success!');
						$location.path('/activity/'+response.data.ActivityNumber);
					}else{
						toastr.success('Activity Updated!','Success!');
					}
				}else{
					toastr.error('Activity Failed To Update!','Uh Oh!');
				}
			});
		};

		vm.deleteActivity = function(){
			DataSyncService.sync('deleteActivity', vm.currentActivityData, function(response){
				if (response.success){
					toastr.success('Activity Deleted!','Success!');
					$location.path('/job/'+vm.currentActivityData['JobId']);
				}else{
					toastr.error('Activity Failed To Delete!','Uh Oh!');
				}
			});
		};

		vm.closeDialog = function(){
			 $mdDialog.hide();
		};
	}

	function QCImageDialogController(data, $mdDialog, $scope) {
		$scope.data = data;
		$scope.cancel = function(){
			$mdDialog.cancel();
		};
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'datatables',
                'gridshore.c3js.chart',
                'pascalprecht.translate',
                'ui.router',
                'ui.sortable',
                'ng-sortable',
                'xeditable',
                'uiGmapgoogle-maps',
                'moment-picker',
                'ksSwiper',
                '720kb.datepicker',
                'toastr',
                'smDateTimeRangePicker',
                'nvd3',
                'ngMaterialDatePicker',
                'mdPickers',
                'angularMoment'
            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
	'use strict';

	angular
		.module('app.user-settings', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.user-settings', {
				url: '/user-settings',
				views: {
					'content@app': {
						templateUrl: 'app/main/user-settings/user-settings.html',
						controller: 'UserSettingsController as vm'
					}
				},
				loginRequired: true
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/user-settings');

		// Navigation
		// msNavigationServiceProvider.saveItem('fuse', {
		// 	title: 'USER-SETTINGS',
		// 	group: true,
		// 	weight: 1
		// });

		msNavigationServiceProvider.saveItem('fuse.user-settings', {
			title: 'User Settings',
			icon: 'icon-people',
			state: 'app.user-settings',
			/*stateParams: {
				'param1': 'page'
			 },*/
			translate: 'USER-SETTINGS.USER-SETTINGS-NAV',
			weight: 4
		});
	}
})();

(function() {
	'use strict';

	angular
		.module('app.user-settings')
		.controller('UserSettingsController', UserSettingsController);

	/** @ngInject */
	function UserSettingsController($rootScope, AuthenticationService, $window, DataSyncService, moment, $mdMedia, uiGmapGoogleMapApi, $mdSidenav, $mdpTimePicker, toastr) {
		var vm = this;
		vm.contacts = angular.copy($rootScope.activeUsers);
		vm.selectedUser;
		vm.log = [];
		vm.mapMarkers = [];
		vm.basicForm = {};
		vm.timeSchedules = [];
		vm.timeSheetDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		vm.isNewUser = false;
		vm.supervisorList = [{}];

		DataSyncService.getActiveUsers(function(data) {
			vm.contacts = data;
			for(var i = 0; data && i < data.length; i++){
				if (data[i].AccessLevel != 3){
					vm.supervisorList.push(data[i]);
				}
			}
		});
		DataSyncService.getTimeSchedules(function(data) {
			vm.timeSchedules = data;
		});

		var onMarkerClicked = function(marker) {
			marker.showWindow = true;
		};

		vm.saveUser = function(){
			DataSyncService.sync('saveUserProfile',vm.selectedUser,function(data){
				if (data.success){
					toastr.success('User Saved!', 'Success');
					DataSyncService.getActiveUsers(function(data) {
						vm.contacts = data;
						vm.supervisorList = [{}];
						for (var i = 0; data && i < data.length; i++) {
							if (data[i].AccessLevel != 3) {
								vm.supervisorList.push(data[i]);
							}
						}
					}, true);
				}else{
					toastr.error(data.data, 'Error');
				}
			});
		}

		vm.unlockDevice = function(){
			vm.selectedUser.Phone = '';
			DataSyncService.sync('saveUserProfile',vm.selectedUser,function(response){
				if (response.success){
					toastr.success('User Device Has Been Unlocked!','Success');
				}else{
					toastr.error('Could Not Unlock User Device!','Error');
				}
			});
		}

		vm.addNewUser = function(){
			vm.isNewUser = true;
			vm.selectedUser = {
				EmailAddress:'',
				FirstName:'',
				LastName:'',
				EmployeeId:'',
				AccessLevel:'',
				Status:'',
				SupervisorId:'',
				timeSchedule:''
			};
		}

		vm.loadUser = function(user) {
			vm.isNewUser = false;
			vm.selectedUser = user;
			vm.selectedUser.LastLocDateTime = new Date();
			vm.selectedUser.Latitude = 33.4180739;
			vm.selectedUser.Longitude = -111.9614925;

			vm.mapMarkers = [{
				id: 'curLoc',
				icon: 'http://maps.google.com/mapfiles/ms/icons/truck.png',
				showWindow: false,
				LogType: 'Last Know Location',
				LogFrom: '',
				LogTo: '',
				DateTime: vm.selectedUser.LastLocDateTime,
				latitude: vm.selectedUser.Latitude,
				longitude: vm.selectedUser.Longitude
			}];
			vm.basicForm = {
				firstname: vm.selectedUser.FirstName,
				lastname: vm.selectedUser.LastName,
				emailaddress: vm.selectedUser.EmailAddress,
				accesslevel: vm.selectedUser.AccessLevel,
				employeeid: vm.selectedUser.EmployeeId,
				userstatus: vm.selectedUser.Status
			};
			DataSyncService.getUserTimeLogs(user.Id, function(data) {
				loadMap(data);
			});
			if ( !$mdMedia('gt-md') )
			{
			    $mdSidenav('left-sidenav').close();
			}
		}

		vm.pingUserLocation = function() {
			//GET USER GPS COORDINATES
		}

		vm.resetPassword = function(){
			DataSyncService.sync('resetPassword',vm.selectedUser,function(data){
				if (data.success){
					toastr.success('Password Reset Email Sent!','Success');
				}else{
					toastr.error('Unable To Reset Password!','Error');
				}
			});
		}

		function loadMap(log) {
			uiGmapGoogleMapApi.then(function(maps) {
				vm.log = log;
				if (!(vm.log instanceof Array)) {
					vm.log = [log];
				}
				for (var i = 0; vm.log && i < vm.log.length; i++) {
					var icn = 'http://maps.google.com/mapfiles/ms/icons/green.png';
					if (vm.log[i].LogType == 'Clocked Out') {
						icn = 'http://maps.google.com/mapfiles/ms/icons/red.png';
					}
					if (vm.log[i].LogType == 'Went On Break') {
						icn = 'http://maps.google.com/mapfiles/ms/icons/yellow.png'
					}
					vm.mapMarkers.push({
						id: i,
						icon: icn,
						showWindow: false,
						LogType: vm.log[i].LogType,
						LogFrom: vm.log[i].LogFrom,
						LogTo: vm.log[i].LogTo,
						DateTime: vm.log[i].DateTime,
						latitude: vm.log[i].Latitude,
						longitude: vm.log[i].Longitude
					});
				}
				vm.simpleMarkerMap = {
					center: {
						latitude: vm.mapMarkers[0].latitude,
						longitude: vm.mapMarkers[0].longitude
					},
					zoom: 8,
					markers: vm.mapMarkers
				};
			});

			_.each(vm.mapMarkers, function(marker) {
				marker.closeClick = function() {
					marker.showWindow = false;
				};
				marker.onClicked = function() {
					onMarkerClicked(marker);
				};
			});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('app.time-schedule-settings', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.time-schedule-settings', {
				url: '/time-schedule-settings',
				views: {
					'content@app': {
						templateUrl: 'app/main/time-schedule-settings/time-schedule-settings.html',
						controller: 'TimeScheduleSettingsController as vm'
					}
				},
				loginRequired: true
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/time-schedule-settings');

		// Navigation
		// msNavigationServiceProvider.saveItem('fuse', {
		// 	title: 'Time Schedule Settings',
		// 	group: true,
		// 	weight: 1
		// });

		msNavigationServiceProvider.saveItem('fuse.time-schedule-settings', {
			title: 'Time Schedules',
			icon: 'icon-calendar',
			state: 'app.time-schedule-settings',
			/*stateParams: {
				'param1': 'page'
			 },*/
			translate: 'TIME-SCHEDULE-SETTINGS.TIME-SCHEDULE-SETTINGS-NAV',
			weight: 3
		});
	}
})();

(function() {
	'use strict';

	angular
		.module('app.time-schedule-settings')
		.controller('TimeScheduleSettingsController', TimeScheduleSettingsController)
		.controller('TimeScheduleDeletePopupController', TimeScheduleDeletePopupController);

	/** @ngInject */
	function TimeScheduleSettingsController($rootScope, AuthenticationService, $window, DataSyncService, moment, $mdMedia, $mdSidenav, $mdpTimePicker, toastr, $mdDialog) {
		var vm = this;
		vm.timeSchedules = [];
		vm.selectedSchedule;
		vm.timeCardForm = {};
		vm.timeSheetDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

		DataSyncService.getTimeSchedules(function(data) {
			vm.timeSchedules = data;
		});

		vm.toggleCheckbox = function(item) {
			if (vm.selectedSchedule.ScheduleData[item].Selected) {
				vm.selectedSchedule.ScheduleData[item].Selected = false;
			} else {
				vm.selectedSchedule.ScheduleData[item].Selected = true;
			}
		};
		vm.toggleSidenav = function(sidenavId){
		    $mdSidenav(sidenavId).toggle();
		};
		vm.exists = function(item) {
			return vm.selectedSchedule.ScheduleData[item].Selected;
		};
		vm.isIndeterminate = function() {
			return (Object.keys(vm.selectedSchedule.ScheduleData).length !== 0 && Object.keys(vm.selectedSchedule.ScheduleData) !== vm.timeSheetDays.length);
		};
		vm.isChecked = function() {
			for (var k in vm.selectedSchedule.ScheduleData){
				if (!vm.selectedSchedule.ScheduleData[k].Selected){
					return false;
				}
			}
			return true;
		};
		vm.toggleAllCheckboxes = function() {
			var has_selected = 0;
			for (var k in vm.selectedSchedule.ScheduleData){
				if (vm.selectedSchedule.ScheduleData[k].Selected){
					has_selected++;
				}
			}
			if (has_selected == vm.timeSheetDays.length){
				for (var k in vm.selectedSchedule.ScheduleData){
					vm.selectedSchedule.ScheduleData[k].Selected = false;
				}
			}else{
				for (var k in vm.selectedSchedule.ScheduleData){
					vm.selectedSchedule.ScheduleData[k].Selected = true;
				}
			}
		};

		var onMarkerClicked = function(marker) {
			marker.showWindow = true;
		};

		vm.showTimePicker = function(ev, idx, fld) {
			var dd = moment().format('YYYY-MM-DD') + ' ' + vm.selectedSchedule.ScheduleData[idx][fld];
			$mdpTimePicker(new Date(dd), {
				targetEvent: ev
			}).then(function(selectedDate) {
				vm.selectedSchedule.ScheduleData[idx][fld] = moment(selectedDate).format('h:mm A');
			});
		};

		vm.loadSchedule = function(schedule) {
			vm.selectedSchedule = schedule;
			if ( !$mdMedia('gt-md') )
			{
			    $mdSidenav('left-sidenav').close();
			}
		};

		vm.saveTimeSchedule = function(d){
			var tmp = angular.copy(vm.selectedSchedule);
			tmp.ScheduleData = JSON.stringify(tmp.ScheduleData);
			DataSyncService.sync('saveTimeSchedule',tmp,function(response){
				if (response.success){
					$rootScope.timeSchedules = [];
					DataSyncService.getTimeSchedules(function(data) {
						vm.timeSchedules = data;
					});
					if (!vm.selectedSchedule.Id){
						vm.selectedSchedule = null;
					}
					toastr.success('Time Schedule Saved!', 'Success');
				}else{
					toastr.error('Failed To Save Time Schedule!', 'Error');
				}
			});
		};

		vm.addNewSchedule = function(){
			vm.selectedSchedule = {
				Name:'',
				ScheduleData:{"Sunday": {"Selected": false,"StartTime": "","EndTime": "","Modifier":1},"Monday": {"Selected": false,"StartTime": "","EndTime": "","Modifier":1},"Tuesday": {"Selected": false,"StartTime": "","EndTime": "","Modifier":1},"Wednesday": {"Selected": false,"StartTime": "","EndTime": "","Modifier":1},"Thursday": {"Selected": false,"StartTime": "","EndTime": "","Modifier":1},"Friday": {"Selected": false,"StartTime": "","EndTime": "","Modifier":1},"Saturday": {"Selected": false,"StartTime": "","EndTime": "","Modifier":1}},
				OtType: 'day',
				OtMin: 420
			};
		};

		vm.deleteTimeSchedule = function(ev) {
			if (vm.timeSchedules.length < 2){
				toastr.error('Unfortunately you do not have any time schedules to swap this one out with!', 'Error');
				return false;
			}
			$mdDialog.show({
				locals: {
					timeSchedules: vm.timeSchedules,
					scheduleDeleting: vm.selectedSchedule
				},
				controller: TimeScheduleDeletePopupController,
				controllerAs: 'vm',
				templateUrl: 'app/main/time-schedule-settings/time-schedule-settings-delete-dialog.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true
			}).then(function(resp) {
				DataSyncService.sync('deleteTimeSchedule',{Id:vm.selectedSchedule.Id, ReplaceWith:resp}, function(response){
					if (response.success) {
						$rootScope.timeSchedules = [];
						DataSyncService.getTimeSchedules(function(data) {
							vm.timeSchedules = data;
						});
						vm.selectedSchedule = null;
						toastr.success('Time Schedule Removed!', 'Success');
					} else {
						toastr.error('Failed To Remove Time Schedule!', 'Error');
					}
				});
			});
		}
	}
	function TimeScheduleDeletePopupController($mdDialog, timeSchedules, scheduleDeleting){
		var vm = this;
		var deletingSchedulePos = timeSchedules.indexOf(scheduleDeleting);
		vm.timeSchedules = angular.copy(timeSchedules);
		vm.timeSchedules.splice(deletingSchedulePos, 1);
		vm.selectedSchedule = null;

		vm.confirmDelete = function() {
			$mdDialog.hide(vm.selectedSchedule);
		}

		vm.cancel = function() {
			$mdDialog.cancel();
		}
	}
})();

(function() {
	'use strict';

	angular.module('app.time-management', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.time-management', {
				url: '/time-management',
				views: {
					'content@app': {
						templateUrl: 'app/main/time-management/time-management.html',
						controller: 'TimeMgmtController as vm'
					}
				},
				loginRequired: true
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/time-management');

		// Navigation
		// msNavigationServiceProvider.saveItem('fuse', {
		// 	title: 'TIME-MANAGEMENT',
		// 	group: true,
		// 	weight: 1
		// });

		msNavigationServiceProvider.saveItem('fuse.time-management', {
			title: 'Time Management',
			icon: 'icon-calendar-clock',
			state: 'app.time-management',
			/*stateParams: {
				'param1': 'page'
			 },*/
			translate: 'TIME-MANAGEMENT.TIME-MANAGEMENT_NAV',
			weight: 1
		});
	}
})();

(function() {
	'use strict';

	angular.module('app.time-management')
		.controller('TimeMgmtController', TimeManagementController)
		.controller('NotesDialogController', NotesDialogController);

	/** @ngInject */
	function TimeManagementController($rootScope, AuthenticationService, $window, DataSyncService, moment, $mdpDatePicker, $mdpTimePicker, toastr, $mdDialog) {
		var vm = this;
		// Data
		vm.currentUserSelected = 0;
		vm.currentTableData = [];
		vm.userData = angular.copy($rootScope.activeUsers);
		vm.userObj = {};
		vm.dataByUser = {
			0: {
				regularHours: 0,
				breakHours: 0,
				otHours: 0,
				totalHours: 0
			}
		};
		vm.pieChart = '';
		vm.dtOptions = {
			dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			pagingType: 'simple',
			autoWidth: false,
			responsive: true,
			sort: false
		};
		vm.mWeekStart = moment().startOf('week').add(1, 'day');
		vm.mWeekEnd = moment().endOf('week').add(1, 'day');

		DataSyncService.getActiveUsers(function(data) {
			var tdata = angular.copy(data);
			tdata.unshift({
				'Id': 0,
				'FirstName': 'All',
				'LastName': 'Users'
			});
			vm.userData = tdata;
			for (var i = 0; vm.userData && i < vm.userData.length; i++) {
				vm.userObj[vm.userData[i].Id] = vm.userData[i];
			}
		});

		vm.init = function() {
			DataSyncService.sync('getWeekLogData', {
				from: moment(vm.mWeekStart).format('YYYY-MM-DD'),
				to: moment(vm.mWeekEnd).format('YYYY-MM-DD')
			}, function(response) {
				if (response.success) {
					vm.dataByUser = {};
					for (var i = 0; response.data && i < response.data.length; i++) {
						if (!vm.dataByUser[response.data[i].UserId]) {
							vm.dataByUser[response.data[i].UserId] = {
								'logs': []
							};
						}
						response.data[i].DateTime = moment(response.data[i].DateTime).toDate();
						vm.dataByUser[response.data[i].UserId].logs.push(response.data[i]);
					}
					if (!vm.dataByUser[0]) {
						vm.dataByUser[0] = {
							regularHours: 0,
							breakHours: 0,
							otHours: 0,
							totalHours: 0
						};
					}
					for (var u in vm.dataByUser) {
						var d = DataSyncService.calculateTimeOverview(vm.dataByUser[u].logs);
						vm.dataByUser[u].regularHours = d.regHours || 0;
						vm.dataByUser[u].breakHours = d.breakHours || 0;
						vm.dataByUser[u].otHours = d.otHours || 0;
						vm.dataByUser[u].totalHours = d.totalHours || 0;
						vm.dataByUser[u].logs = d.logs;

						vm.dataByUser[0].regularHours += vm.dataByUser[u].regularHours;
						vm.dataByUser[0].breakHours += vm.dataByUser[u].breakHours;
						vm.dataByUser[0].otHours += vm.dataByUser[u].otHours;
						vm.dataByUser[0].totalHours += vm.dataByUser[u].totalHours;
					}
					console.log(vm.dataByUser);
					vm.changeDataChart();
				}
			});
		}

		vm.updateLogStatus = function(l){
			DataSyncService.sync('saveTimeLogAdmin', l, function(response){
				if (response.success) {
					toastr.success('Time Log Successfully Updated!', 'Success');
				} else {
					toastr.error('Time Log Failed To Update!', 'Error');
				}
			});
		}

		vm.showTimePicker = function(ev, d, a) {
			var dd = moment().format('YYYY-MM-DD') + ' ' + d[a];
			var tempd = angular.copy(d);
			console.log(dd);
			$mdpTimePicker(new Date(dd), {
				targetEvent: ev
			}).then(function(selectedDate) {
				if (a == 'LogFrom') {
					var sd = moment(selectedDate);
					var dt = moment(d.DateTime).hours(sd.hours()).minutes(sd.minutes());
					d['DateTime'] = dt.toDate();
					tempd['DateTime'] = dt.toJSON();
				}
				d[a] = moment(selectedDate).format('h:mm A');
				tempd[a] = moment(selectedDate).format('h:mm A');
				DataSyncService.sync('saveTimeLogAdmin', tempd, function(response) {
					if (response.success) {
						toastr.success('Time Log Successfully Updated!', 'Success');
					} else {
						toastr.error('Time Log Failed To Update!', 'Error');
					}
				});
			});
		}

		vm.changeDataChart = function() {
			if (vm.currentUserSelected == 0) {
				var logs = [];
				for (var u in vm.dataByUser) {
					if (vm.dataByUser[u].logs)
						logs = logs.concat(vm.dataByUser[u].logs);
				}
				vm.currentTableData = logs;
			} else {
				if (vm.dataByUser[vm.currentUserSelected]) {
					vm.currentTableData = vm.dataByUser[vm.currentUserSelected].logs;
				} else {
					vm.currentTableData = [];
				}
			}
		};

		vm.displayNote = function(ev, log) {
			$mdDialog.show({
				locals: {
					log: log
				},
				controller: NotesDialogController,
				controllerAs: 'vm',
				templateUrl: 'app/main/time-management/time-management-notes-dialog.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true
			}).then(function(resp) {
				log = resp;
				DataSyncService.sync('saveTimeLogAdmin', log, function(response) {
					if (response.success) {
						toastr.success('Notes Saved!', 'Success');
					} else {
						toastr.error('Notes Failed To Update!', 'Error');
					}
				});
			});
		}

		vm.viewAllOnMap = function(ev) {
			$mdDialog.show({
				locals: {
					log: vm.currentTableData
				},
				controller: MapsDialogController,
				controllerAs: 'vm',
				templateUrl: 'app/main/time-management/time-management-map-dialog.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true
			});
		}

		vm.displayLogMap = function(ev, log) {
			$mdDialog.show({
				locals: {
					log: log
				},
				controller: MapsDialogController,
				controllerAs: 'vm',
				templateUrl: 'app/main/time-management/time-management-map-dialog.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true
			});
		}

		this.init();
	}

	/** @ngInject */
	function NotesDialogController($mdDialog, log) {
		var vm = this;
		vm.log = log;

		vm.saveNotes = function() {
			$mdDialog.hide(vm.log);
		}

		vm.cancel = function() {
			$mdDialog.cancel();
		}
	}

	/** @ngInject */
	function MapsDialogController($mdDialog, log, uiGmapGoogleMapApi) {
		var vm = this;
		vm.log = log;
		vm.mapMarkers = [];


		uiGmapGoogleMapApi.then(function(maps) {
			if (!(vm.log instanceof Array)) {
				vm.log = [log];
			}
			for (var i = 0; i < vm.log.length; i++) {
				var icn = 'http://maps.google.com/mapfiles/ms/icons/green.png';
				if (vm.log[i].LogType == 'Clocked Out'){
					icn = 'http://maps.google.com/mapfiles/ms/icons/red.png';
				}
				if (vm.log[i].LogType == 'Went On Break'){
					icn = 'http://maps.google.com/mapfiles/ms/icons/yellow.png'
				}
				vm.mapMarkers.push({
					id: i,
					icon: icn,
					showWindow: false,
					title: 'My Marker',
					LogType: vm.log[i].LogType,
					LogFrom: vm.log[i].LogFrom,
					LogTo: vm.log[i].LogTo,
					DateTime: vm.log[i].DateTime,
					latitude: vm.log[i].Latitude,
					longitude: vm.log[i].Longitude
				});
			}
			console.log(vm.mapMarkers);
			vm.simpleMarkerMap = {
				center: {
					latitude: vm.mapMarkers[0].latitude,
					longitude: vm.mapMarkers[0].longitude
				},
				zoom: 8,
				markers: vm.mapMarkers
			};

			vm.customMarkerMap = {
				center: {
					latitude: -25.363882,
					longitude: 131.044922
				},
				zoom: 8,
				marker: {
					id: 0,
					coords: {
						latitude: -25.363882,
						longitude: 131.044922
					},
					options: {
						icon: {
							anchor: new maps.Point(36, 36),
							origin: new maps.Point(0, 0),
							url: '//google-developers.appspot.com/maps/documentation/javascript/examples/full/images/beachflag.png'
						}
					}
				}
			};

		});
		var onMarkerClicked = function(marker) {
			marker.showWindow = true;
		};

		_.each(vm.mapMarkers, function(marker) {
			marker.closeClick = function() {
				marker.showWindow = false;
				vm.$apply();
			};
			marker.onClicked = function() {
				onMarkerClicked(marker);
			};
		});

		vm.cancel = function() {
			$mdDialog.cancel();
		}
	}

})();

(function() {
	'use strict';
	angular.module('app.core')
		.factory('DataSyncService', DataSyncService);

	function DataSyncService($cookies, AuthenticationService, $http, $rootScope, moment) {
		var service = {};

		service.sync = function(func, data, callback) {
			var postData = data;
			postData.func = func;
			$http.post('http://timetrackerapi.bosslync.com', postData).then(
				function(response) {
					response.success = true;
					callback(response);
				},
				function(response) {
					response.success = false;
					callback(response);
				}
			);
		};

		service.getActiveUsers = function(callback, forceResync) {
			if (!$rootScope.activeUsers || !$rootScope.activeUsers.length || forceResync) {
				this.sync('getActiveUsers', {}, function(response) {
					if (response.success) {
						$rootScope.activeUsers = response.data;
						callback(response.data);
					} else {
						callback([]);
					}
				});
			} else {
				callback($rootScope.activeUsers);
			}
		};

		service.getSupervisorList = function(callback) {
			return this.getActiveUsers(function(data){
				var supervisors = [];
				for(var i = 0; data && i < data.length; i++){
					if (data[i].AccessLevel != 3){
						supervisors.push(data[i]);
					}
				}
				return supervisors;
			});
		}

		service.getUserTimeLogs = function(userId, callback){
			this.sync('getUserTimeLogs', {From: moment().format('YYYY-MM-DD'), To: moment().format('YYYY-MM-DD'), UserId: userId}, function(response){
				if (response.success) {
					$rootScope.activeUsers = response.data;
					callback(response.data);
				} else {
					callback([]);
				}
			});
		}

		service.getTimeSchedules = function(callback){
			if (!$rootScope.timeSchedules || !$rootScope.timeSchedules.length) {
				this.sync('getTimeSchedules', {}, function(response) {
					if (response.success) {
						var tdata = response.data;
						for (var i = 0; i < tdata.length; i++){
							tdata[i].ScheduleData = JSON.parse(tdata[i].ScheduleData);
						}
						$rootScope.timeSchedules = tdata;
						callback(tdata);
					} else {
						callback([]);
					}
				});
			} else {
				callback($rootScope.timeSchedules);
			}
		}

		service.isOnOt = function(min, regHours){
			var otDiff = 0;
			var reg = 0;

			if (regHours != '-'){
				reg = regHours;
			}

			if (((reg*60)+min) > 480){
				otDiff = ((reg * 60) + min) - 480;
			}
			return otDiff;
		};

		service.calculateTimeOverview = function(timeLogs){
			var lastLog = null,
				diffInMin = 0,
				otMin = 0,
				tl;
			var otHours = 0;
			var regHours = 0;
			var breakHours = 0;
			var totalOtHours = 0;
			var totalRegHours = 0;
			var totalHours = 0;
			var totalBreakHours = 0;
			var dailyOtHours = 0;
			var dailyRegHours = 0;
			// console.log('TLOGS',timeLogs);
			if (timeLogs && timeLogs.length > 0) {
				for (var i = 0; i < timeLogs.length; i++) {
					otHours = 0;
					regHours = 0;
					breakHours = 0;
					tl = timeLogs[i];
					diffInMin = 0;
					otMin = 0;
					if (i > 0){
						if (parseInt(moment(tl.DateTime).format('d')) != parseInt(moment(timeLogs[i-1].DateTime).format('d'))){
							dailyOtHours = 0;
							dailyRegHours = 0;
						}
					}
					// console.log(i, tl);
					if (i == 0) {
						if (tl.LogType != 'Clocked In') {
							//From 12am to whatever time this log is will be logged as in (there is potential that a user could have been on break and clocked out.... revisit this)
							diffInMin = Math.round((moment(tl.DateTime).diff(moment(tl.DateTime).startOf('day'), "minutes")) * 100) / 100;
							otMin = this.isOnOt(diffInMin, dailyRegHours);
							if (otMin) {
								totalOtHours = Math.round((parseFloat(totalOtHours) + (Math.round((otMin / 60) * 100) / 100)) * 100) / 100;
								dailyOtHours = Math.round((parseFloat(dailyOtHours) + (Math.round((otMin / 60) * 100) / 100)) * 100) / 100;
								diffInMin -= otMin;
							}
							if (diffInMin) {
								if (moment().format('dddd') == 'Sunday') {
									totalRegHours = Math.round((parseFloat(totalRegHours) + (Math.round(((diffInMin * 1.5) / 60) * 100) / 100)) * 100) / 100;
									dailyRegHours = Math.round((parseFloat(dailyRegHours) + (Math.round(((diffInMin * 1.5) / 60) * 100) / 100)) * 100) / 100;
								}else{
									totalRegHours = Math.round((parseFloat(totalRegHours) + (Math.round((diffInMin / 60) * 100) / 100)) * 100) / 100;
									dailyRegHours = Math.round((parseFloat(dailyRegHours) + (Math.round((diffInMin / 60) * 100) / 100)) * 100) / 100;
								}
							}
						} else if (tl.from_break) {
							diffInMin = Math.round((moment(tl.DateTime).diff(moment(tl.DateTime).startOf('day'), "minutes")) * 100) / 100;
							totalBreakHours = Math.round((parseFloat(totalBreakHours) + (Math.round((diffInMin / 60) * 100) / 100)) * 100) / 100;
						}
					} else {
						lastLog = timeLogs[i - 1];
						if (lastLog.LogType == 'Clocked In') {
							diffInMin = Math.round((moment(tl.DateTime).diff(moment(lastLog.DateTime), "minutes")) * 100) / 100;
							// console.log('DIFF IN MIN', diffInMin);
							otMin = this.isOnOt(diffInMin, dailyRegHours);
							// console.log('OT MIN', otMin);
							if (otMin) {
								otHours = Math.round((otMin / 60) * 100) / 100;
								totalOtHours = Math.round((parseFloat(totalOtHours) + (Math.round((otMin / 60) * 100) / 100)) * 100) / 100;
								dailyOtHours = Math.round((parseFloat(dailyOtHours) + (Math.round((otMin / 60) * 100) / 100)) * 100) / 100;
								diffInMin -= otMin;
							}
							if (diffInMin) {
								if (moment(lastLog.DateTime).format('dddd') == 'Sunday') {
									regHours = Math.round(((diffInMin * 1.5) / 60) * 100) / 100;
									totalRegHours = Math.round((parseFloat(totalRegHours) + (Math.round(((diffInMin * 1.5) / 60) * 100) / 100)) * 100) / 100;
									dailyRegHours = Math.round((parseFloat(dailyRegHours) + (Math.round(((diffInMin * 1.5) / 60) * 100) / 100)) * 100) / 100;
								}else{
									regHours = Math.round((diffInMin / 60) * 100) / 100;
									totalRegHours = Math.round((parseFloat(totalRegHours) + (Math.round((diffInMin / 60) * 100) / 100)) * 100) / 100;
									dailyRegHours = Math.round((parseFloat(dailyRegHours) + (Math.round((diffInMin / 60) * 100) / 100)) * 100) / 100;
								}
							}
							// console.log('DAILY REG', dailyRegHours);
							// console.log('DAILY OT', dailyOtHours);
							// console.log('HOURS',dailyRegHours + dailyOtHours);
							timeLogs[i-1].hours = Math.round((dailyRegHours + dailyOtHours) * 100)/100;
							timeLogs[i-1].otHours = otHours;
							timeLogs[i-1].regHours = regHours;
						} else if (lastLog.LogType == 'Went On Break') {
							diffInMin = Math.round((moment(tl.DateTime).diff(moment(lastLog.DateTime), "minutes")) * 100) / 100;
							totalBreakHours = Math.round((parseFloat(totalBreakHours) + (Math.round((diffInMin / 60) * 100) / 100)) * 100) / 100;
							timeLogs[i-1].hours = Math.round((diffInMin / 60) * 100) / 100;
							timeLogs[i-1].otHours = 0;
							timeLogs[i-1].regHours = 0;
						}else{
							timeLogs[i-1].hours = 0;
							timeLogs[i-1].otHours = 0;
							timeLogs[i-1].regHours = 0;
						}
					}
				}
			}
			// console.log('TIMELOGS',timeLogs);
			totalHours = totalRegHours + totalBreakHours + totalOtHours;
			if (totalHours > 0) {
				totalHours = Math.round(totalHours * 100) / 100;
			}
			var rObj = {
				regHours: totalRegHours,
				breakHours: totalBreakHours,
				otHours: totalOtHours,
				totalHours: totalHours,
				logs: timeLogs
			};
			return rObj;
		};

		return service;
	}
})();

(function() {
	'use strict';
	angular.module('app.core')
		.factory('AuthenticationService', AuthenticationService)
		.factory('Base64', Base64);

	function AuthenticationService(Base64, $cookies, $rootScope, $http) {
		var service = {};

		service.Login = function(email, password, callback) {
			$http.post('http://timetrackerapi.bosslync.com', {
				email: email,
				password: password,
				func: 'login'
			}).then(
				function(response) {
					response.success = true;
					callback(response);
				},
				function(response) {
					response.success = false;
					callback(response);
				}
			);
		};
		service.VerifyLoggedIn = function(callback){
			var currentUser = $cookies.getObject('globals');
			if (!currentUser){
				callback(false);
				return false;
			}else{
				currentUser = currentUser.currentUser;
			}
			this.setAuthHeader(currentUser.authdata);
			$http.post('http://timetrackerapi.bosslync.com', {
				func: 'checkLogin'
			}).then(
				function(response) {
					response.success = true;
					callback(response);
				},
				function(response) {
					response.success = false;
					callback(response);
				}
			);
		};
		service.setAuthHeader = function(authdata){
			$http.defaults.headers.common['Authorization'] = 'Basic ' + authdata;
		};
		service.getAuthHeader = function(){
			return $http.defaults.headers.common['Authorization'];
		}
		service.UpdateCredentials = function(email, password){
			var authdata = Base64.encode(email + ':' + password);
			$http.defaults.headers.common['Authorization'] = 'Basic ' + authdata;
			$rootScope.globals.currentUser.authdata = authdata;
			$cookies.put('globals', JSON.stringify($rootScope.globals));
		};
		service.SetCredentials = function(email, password) {
			var authdata = Base64.encode(email + ':' + password);
			$rootScope.globals = {
				currentUser: {
					email: email,
					authdata: authdata
				}
			};

			$http.defaults.headers.common['Authorization'] = 'Basic ' + authdata; // jshint ignore:line
			$cookies.put('globals', JSON.stringify($rootScope.globals));
		};
		service.ClearCredentials = function() {
			$rootScope.globals = {};
			$cookies.remove('globals');
			$http.defaults.headers.common.Authorization = 'Basic ';
		};
		service.setCurrentUser = function(userData){
			var c = $rootScope.globals.currentUser;
			if (c){
				for (var k in userData){
					c[k] = userData[k];
				}
			}else{
				c = userData;
			}
			$rootScope.globals.currentUser = c;
			$cookies.put('globals', JSON.stringify($rootScope.globals));
		};
		service.getCurrentUser = function(callback){
			var c = JSON.parse($cookies.get('globals'));
			return c.currentUser;
		};
		return service;
	}

	function Base64() {
		/* jshint ignore:start */

		var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

		return {
			encode: function(input) {
				var output = "";
				var chr1, chr2, chr3 = "";
				var enc1, enc2, enc3, enc4 = "";
				var i = 0;

				do {
					chr1 = input.charCodeAt(i++);
					chr2 = input.charCodeAt(i++);
					chr3 = input.charCodeAt(i++);

					enc1 = chr1 >> 2;
					enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
					enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
					enc4 = chr3 & 63;

					if (isNaN(chr2)) {
						enc3 = enc4 = 64;
					} else if (isNaN(chr3)) {
						enc4 = 64;
					}

					output = output +
						keyStr.charAt(enc1) +
						keyStr.charAt(enc2) +
						keyStr.charAt(enc3) +
						keyStr.charAt(enc4);
					chr1 = chr2 = chr3 = "";
					enc1 = enc2 = enc3 = enc4 = "";
				} while (i < input.length);

				return output;
			},

			decode: function(input) {
				var output = "";
				var chr1, chr2, chr3 = "";
				var enc1, enc2, enc3, enc4 = "";
				var i = 0;

				// remove all characters that are not A-Z, a-z, 0-9, +, /, or =
				var base64test = /[^A-Za-z0-9\+\/\=]/g;
				if (base64test.exec(input)) {
					window.alert("There were invalid base64 characters in the input text.\n" +
						"Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
						"Expect errors in decoding.");
				}
				input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

				do {
					enc1 = keyStr.indexOf(input.charAt(i++));
					enc2 = keyStr.indexOf(input.charAt(i++));
					enc3 = keyStr.indexOf(input.charAt(i++));
					enc4 = keyStr.indexOf(input.charAt(i++));

					chr1 = (enc1 << 2) | (enc2 >> 4);
					chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
					chr3 = ((enc3 & 3) << 6) | enc4;

					output = output + String.fromCharCode(chr1);

					if (enc3 != 64) {
						output = output + String.fromCharCode(chr2);
					}
					if (enc4 != 64) {
						output = output + String.fromCharCode(chr3);
					}

					chr1 = chr2 = chr3 = "";
					enc1 = enc2 = enc3 = enc4 = "";

				} while (i < input.length);

				return output;
			}
		};

		/* jshint ignore:end */
	}
})();

(function() {
    'use strict';

    angular
        .module('app.route-tracking', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.route-tracking', {
                url: '/route-tracking',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/route-tracking/route-tracking.html',
                        controller: 'RouteTrackingController as vm'
                    }
                },
                loginRequired: true
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/route-tracking');

        msNavigationServiceProvider.saveItem('fuse.route-tracking', {
            title: 'Route Tracking',
            icon: 'icon-map',
            state: 'app.route-tracking',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'ROUTE-TRACKING.ROUTE-TRACKING-NAV',
            weight: 4
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.route-tracking')
        .controller('RouteTrackingController', RouteTrackingController);

    /** @ngInject */
    function RouteTrackingController($rootScope, AuthenticationService, $mdpDatePicker, $mdpTimePicker, $window, DataSyncService, moment, uiGmapGoogleMapApi){
        var vm = this;
        // Data
        vm.currentUserSelected = 0;
        vm.currentTableData = [];
        vm.userData = angular.copy($rootScope.activeUsers);
        vm.mWeekStart = moment().startOf('week').add(1, 'day');
        vm.mWeekEnd = moment().endOf('week').add(1, 'day');
        vm.refreshMap = false;
        vm.dataByUser = {
            0: {
                regularHours: 0,
                breakHours: 0,
                otHours: 0,
                totalHours: 0,
                logs: []
            }
        };
        vm.gpsByUser = {
            0: {
                logs: []
            }
        };
        vm.allMarkers = [];
        vm.mapMarkers = [];
        vm.userObj = {};

        DataSyncService.getActiveUsers(function(data) {
            var tdata = angular.copy(data);
            tdata.unshift({
                'Id': 0,
                'FirstName': 'All',
                'LastName': 'Users'
            });
            vm.userData = tdata;
            for (var i = 0; vm.userData && i < vm.userData.length; i++) {
                vm.userObj[vm.userData[i].Id] = vm.userData[i];
            }
        });

        vm.init = function() {
            DataSyncService.sync('getWeekLogData', {
                from: moment(vm.mWeekStart).format('YYYY-MM-DD'),
                to: moment(vm.mWeekEnd).format('YYYY-MM-DD')
            }, function(response) {
                if (response.success) {
                    vm.dataByUser = {
                        0: {
                            regularHours: 0,
                            breakHours: 0,
                            otHours: 0,
                            totalHours: 0,
                            logs: []
                        }
                    };
                    for (var i = 0; response.data && i < response.data.length; i++) {
                        if (!vm.dataByUser[response.data[i].UserId]) {
                            vm.dataByUser[response.data[i].UserId] = {
                                'logs': []
                            };
                        }
                        response.data[i].DateTime = moment(response.data[i].DateTime).toDate();
                        vm.dataByUser[response.data[i].UserId].logs.push(response.data[i]);
                        vm.dataByUser[0].logs.push(response.data[i]);
                    }
                    if (!vm.dataByUser[0]) {
                        vm.dataByUser[0] = {
                            regularHours: 0,
                            breakHours: 0,
                            otHours: 0,
                            totalHours: 0,
                            logs: []
                        };
                    }
                    for (var u in vm.dataByUser) {
                        var d = DataSyncService.calculateTimeOverview(vm.dataByUser[u].logs);
                        vm.dataByUser[u].regularHours = d.regHours || 0;
                        vm.dataByUser[u].breakHours = d.breakHours || 0;
                        vm.dataByUser[u].otHours = d.otHours || 0;
                        vm.dataByUser[u].totalHours = d.totalHours || 0;
                        vm.dataByUser[u].logs = d.logs;

                        vm.dataByUser[0].regularHours += vm.dataByUser[u].regularHours;
                        vm.dataByUser[0].breakHours += vm.dataByUser[u].breakHours;
                        vm.dataByUser[0].otHours += vm.dataByUser[u].otHours;
                        vm.dataByUser[0].totalHours += vm.dataByUser[u].totalHours;
                    }
                    if (vm.dataByUser[0].logs.length){
                        console.log('DBYUSER',vm.dataByUser[0].logs);
                        loadMap(vm.dataByUser[0].logs);
                    }
                }
            });
            DataSyncService.sync('getGPSTracking',{
                from: moment(vm.mWeekStart).format('YYYY-MM-DD'),
                to: moment(vm.mWeekEnd).format('YYYY-MM-DD')
            }, function(response){
                if (response.success){
                    for (var i = 0; response.data && i < response.data.length; i++) {
                        if (!vm.gpsByUser[response.data[i].UserId]) {
                            vm.gpsByUser[response.data[i].UserId] = {
                                'logs': []
                            };
                        }
                        response.data[i].DateTime = moment(response.data[i].DateTime).toDate();
                        vm.gpsByUser[response.data[i].UserId].logs.push(response.data[i]);
                        vm.gpsByUser[0].logs.push(response.data[i]);
                    }
                    if (vm.gpsByUser[0].logs.length){
                        console.log('GPSBYUSER',vm.gpsByUser[0].logs);
                        loadMap(vm.gpsByUser[0].logs);
                    }
                }
            });
        }

        vm.loadGPSDataByUser = function(){
            var logs = [];
            var user = vm.currentUserSelected;
            console.log('USER',user);
            if (vm.dataByUser[user] && vm.dataByUser[user].logs){
                for (var i = 0; i < vm.dataByUser[user].logs.length; i++){
                    logs.push(vm.dataByUser[user].logs[i]);
                }
            }
            if (vm.gpsByUser[user] && vm.gpsByUser[user].logs){
                for (var i = 0; i < vm.gpsByUser[user].logs.length; i++){
                    logs.push(vm.gpsByUser[user].logs[i]);
                }
            }
            vm.mapMarkers = [];
            vm.simpleMarkerMap.markers = [];
            loadMap(logs);
        }

        function loadMap(log) {
            uiGmapGoogleMapApi.then(function(maps) {
                if (!(log instanceof Array)) {
                    log = [log];
                }
                for (var i = 0; i < log.length; i++) {
                    var icn = 'http://maps.google.com/mapfiles/ms/icons/green.png';
                    if (log[i].LogType == 'Clocked Out'){
                        icn = 'http://maps.google.com/mapfiles/ms/icons/red.png';
                    }
                    if (log[i].LogType == 'Went On Break'){
                        icn = 'http://maps.google.com/mapfiles/ms/icons/yellow.png'
                    }
                    if (!log[i].LogFrom){
                        log[i].LogFrom = moment(log[i].DateTime).format('h:m A');
                    }
                    vm.mapMarkers.push({
                        id: i,
                        icon: icn,
                        showWindow: false,
                        LogType: log[i].LogType,
                        LogFrom: log[i].LogFrom,
                        LogTo: log[i].LogTo,
                        DateTime: log[i].DateTime,
                        latitude: log[i].Latitude,
                        longitude: log[i].Longitude,
                        user: (vm.userObj[log[i].UserId]) ? vm.userObj[log[i].UserId].FirstName + ' ' + vm.userObj[log[i].UserId].LastName : 'No Name'
                    });
                }
                if (vm.mapMarkers.length){
                    vm.simpleMarkerMap = {
                        center: {
                            latitude: vm.mapMarkers[0].latitude || 0.0,
                            longitude: vm.mapMarkers[0].longitude || 0.0
                        },
                        zoom: 8,
                        markers: vm.mapMarkers
                    };
                }
            });
            var onMarkerClicked = function(marker) {
                marker.showWindow = true;
            };

            _.each(vm.mapMarkers, function(marker) {
                marker.closeClick = function() {
                    marker.showWindow = false;
                    vm.$apply();
                };
                marker.onClicked = function() {
                    onMarkerClicked(marker);
                };
            });
        }
        vm.init();
    }

})();

(function() {
	'use strict';

	angular
		.module('app.login', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider) {
		// State
		$stateProvider.state('app.login', {
			url: '/login',
			views: {
				'main@': {
					templateUrl: 'app/core/layouts/content-only.html',
					controller: 'MainController as vm'
				},
				'content@app.login': {
					templateUrl: 'app/main/login/login.html',
					controller: 'LoginController as vm'
				}
			},
			bodyClass: 'login',
			// resolve: {
			// 	UserData: function (msApi){
			// 		return msApi.resolve('login@post');
			// 	}
			// }
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/login');

		// Navigation
		// msNavigationServiceProvider.saveItem('pages.login', {
		// 	title: 'Login',
		// 	state: 'app.pages_login',
		// 	weight: 2
		// });

		msApiProvider.register('login',['http://dropapi.bosslync.com']);
	}

})();

(function() {
	'use strict';

	angular
		.module('app.login')
		.controller('LoginController', LoginController);

	/** @ngInject */
	function LoginController($rootScope, $timeout, $scope, $window, $cookies, AuthenticationService, $http, $mdDialog) {
		// Data
		var vm = this;
		vm.loginFailure = {
			error: false
		};
		// Methods
		this.submitLogin = function() {
			var email = this.form.email;
			var pass = this.form.password;
			AuthenticationService.Login(email, pass, function(response) {
				if (response.success) {
					if (response.data.AccessLevel === 3) {
						alert = $mdDialog.alert({
							title: 'Attention',
							textContent: 'You do not have access to the admin panel. Contact your administrator!',
							ok: 'Close'
						});
						$mdDialog
							.show(alert)
							.finally(function() {
								alert = undefined;
							});
						return false;
					}
					AuthenticationService.SetCredentials(email, pass);
					AuthenticationService.setCurrentUser(response.data);
					$window.location.href = '/dashboard';
				} else {
					$scope.$apply(function() {
						vm.loginFailure.error = true;
					});
					$timeout(function() {
						$scope.$apply(function() {
							vm.loginFailure.error = false;
						});
					}, 1500);
				}
			});
		};
	}
})();

(function() {
	'use strict';

	angular
		.module('app.node', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.node', {
				url: '/node/:nodeId',
				views: {
					'content@app': {
						templateUrl: 'app/main/node/node.html',
						controller: 'NodeController as vm'
					}
				},
				loginRequired: true
			})
			.state('app.node.edit',{
				url: '/edit',
				views: {
					'content@app':{
						templateUrl: 'app/main/node/node_edit.html',
						controller: 'NodeController as vm'
					}
				},
				loginRequired: true
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/node');

		// // Navigation
		// msNavigationServiceProvider.saveItem('fuse', {
		// 	title: 'NODE',
		// 	group: true,
		// 	weight: 1
		// });

		// msNavigationServiceProvider.saveItem('fuse.dashboard', {
		// 	title: 'Dashboard',
		// 	icon: 'icon-tile-four',
		// 	state: 'app.dashboard',
		// 	/*stateParams: {
		// 		'param1': 'page'
		// 	 },*/
		// 	translate: 'DASHBOARD.DASHBOARD_NAV',
		// 	weight: 1
		// });
	}
})();

(function() {
	'use strict';

	angular
		.module('app.node')
		.controller('NodeController', NodeController);

	/** @ngInject */
	function NodeController($rootScope, AuthenticationService, DataSyncService, $stateParams, $location, $timeout, $window) {
		var vm = this;

		vm.nodeId = $stateParams.nodeId;
		vm.currentNodeData = {};
		vm.dtOptions = {
			dom: '<"top"<"table-label">f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			pagingType: 'simple',
			autoWidth: false,
			responsive: true,
		};

		DataSyncService.sync('getNodeData',{id:vm.nodeId},function(response){
			if (response.success){
				vm.currentNodeData = response.data;
			}else{
				$location.path('/dashboard');
			}
		});

		vm.saveNode = function(){
			console.log(vm.currentNodeData);
			var saveObject = angular.copy(vm.currentNodeData);
			DataSyncService.sync('saveNode',saveObject,function(response){
				if (response.success){
					if (vm.jobId === 'new'){
						toastr.success('Node Created!','Success!');
						$location.path('/node/'+response.data.Id);
					}else{
						toastr.success('Node Updated!','Success!');
						$location.path('/node/'+response.data.Id);
					}
				}else{
					toastr.error('Node Failed To Update!','Uh Oh!');
				}
			});
		};

		vm.cancelEdit = function(){
			$window.history.back();
		}

		$timeout(function(){
			var d = document.querySelector('.table-label');
			var el = angular.element(document.querySelector('.table-label'));
			el.html('<h1>Node Job Listing</h1>');
		},3000);
	}
})();

(function() {
	'use strict';

	angular
		.module('app.job', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.job', {
				url: '/job/:jobId',
				views: {
					'content@app': {
						templateUrl: 'app/main/job/job.html',
						controller: 'JobController as vm'
					}
				},
				loginRequired: true
			})
			.state('app.job.edit', {
				url: '/edit',
				views: {
					'content@app': {
						templateUrl: 'app/main/job/job_edit.html',
						controller: 'JobController as vm'
					}
				},
				loginRequired: true
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/job');

		// // Navigation
		// msNavigationServiceProvider.saveItem('fuse', {
		// 	title: 'NODE',
		// 	group: true,
		// 	weight: 1
		// });

		// msNavigationServiceProvider.saveItem('fuse.dashboard', {
		// 	title: 'Dashboard',
		// 	icon: 'icon-tile-four',
		// 	state: 'app.dashboard',
		// 	/*stateParams: {
		// 		'param1': 'page'
		// 	 },*/
		// 	translate: 'DASHBOARD.DASHBOARD_NAV',
		// 	weight: 1
		// });
	}
})();

(function() {
	'use strict';

	angular
		.module('app.job')
		.controller('JobController', JobController);

	/** @ngInject */
	function JobController($rootScope, AuthenticationService, DataSyncService, $stateParams, $location, $timeout, $mdDialog, moment, $window) {
		var vm = this;

		vm.jobId = $stateParams.jobId;
		vm.currentJobData = {};
		vm.qcImages = [];
		vm.dtOptions = {
			dom: '<"top"<"table-label">f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			pagingType: 'simple',
			autoWidth: false,
			responsive: true,
		};
		vm.swiperElem;

		DataSyncService.sync('getJobData', {
			id: vm.jobId
		}, function(response) {
			if (response.success) {
				vm.currentJobData = response.data;
				vm.currentJobData.TargetStart =	moment(response.data.TargetStart).toDate();
				for (var i = 0; response.data.Activities && i < response.data.Activities.length; i++){
					vm.currentJobData.Activities[i].StartDate = moment(response.data.Activities[i].StartDate).format('M/DD/YYYY');
					var tm = vm.currentJobData.Activities[i].StartTime;
					if (tm){
						tm = tm.split(":");
						vm.currentJobData.Activities[i].StartTime = moment().hour(tm[0]).minute(tm[1]).second(0).format('h:mm A');
					}else{
						vm.currentJobData.Activities[i].StartTime = 'Not Set';
					}
				}
				for (var i = 0; response.data.QualityControl && i < response.data.QualityControl.length; i++) {
					var title = response.data.QualityControl[i].ActivityNumber;
					var txt = response.data.QualityControl[i].QcActivityNumber;
					for (var z = 0; response.data.QualityControl[i].Images && z < response.data.QualityControl[i].Images.length; z++) {
						vm.qcImages.push({
							'title': title,
							'text': txt,
							'media': {
								'image': {
									'src': response.data.QualityControl[i].Images[z].ImageUrl,
									'alt': txt + ' image ' + z
								}
							}
						});
					}
				}
			} else {
				$location.path('/dashboard');
			}
		});

		$timeout(function() {
			var d = document.querySelector('.table-label');
			var el = angular.element(document.querySelector('.table-label'));
			el.html('<h1>Activity Listing</h1>');
			if (vm.swiperElem){
				vm.swiperElem.update();
			}
		}, 3000);

		vm.initSwiper = function(swiper) {
			vm.swiperElem = swiper;
		};

		vm.onQcClick = function(qcImage, ev) {
			$mdDialog.show({
				controller: QCImageDialogController,
				templateUrl: '/app/main/job/job.qcimage.dialog.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					data: qcImage
				}
			});
		};

		vm.saveJob = function(){
			var saveObject = angular.copy(vm.currentJobData);
			console.log(saveObject);
			DataSyncService.sync('saveJob',saveObject,function(response){
				if (response.success){
					if (vm.jobId === 'new'){
						toastr.success('Job Created!','Success!');
						$location.path('/job/'+response.data.Id);
					}else{
						toastr.success('Job Updated!','Success!');
						$location.path('/job/'+response.data.Id);
					}
				}else{
					toastr.error('Job Failed To Update!','Uh Oh!');
				}
			});
		};

		vm.cancelEdit = function(){
			$window.history.back();
		}
	}

	function QCImageDialogController(data, $mdDialog, $scope) {
		$scope.data = data;
		$scope.cancel = function(){
			$mdDialog.cancel();
		};
	}
})();

(function() {
	'use strict';

	angular.module('app.gantt-chart')
		.controller('GanttChartController', GanttChartController);

	/** @ngInject */
	function GanttChartController($mdDialog, $document, $animate, $scope, $timeout, ganttUtils, GanttObjectModel, ganttDebounce, moment, $window, $mdSidenav, msApi, DataSyncService, toastr) {
		var vm = this;
		var objectModel;
		var Tasks = {'data':[]};
		var Timespans = {};

		DataSyncService.sync('getGanttData', {
			min_date : moment.utc().subtract(1,'days').toDate(),
			max_date : moment.utc().add(1,'days').toDate()
		}, function(response) {
			var temp_data = {};
			if (response.success) {
				//Break out activities by tech
				for (var i = 0; response.data && response.data.activities && i < response.data.activities.length; i++){
					var d = response.data.activities[i];
					if (!temp_data[d.TechId]){
						temp_data[d.TechId] = [];
					}
					temp_data[d.TechId].push(d);
				}
				//Inject the users into the data to ensure all users are listed
				for (var i = 0; response.data.users && i < response.data.users.length; i++){
					if (!temp_data[response.data.users[i]['Id']]){
						temp_data[response.data.users[i]['Id']] = [];
					}
					temp_data[response.data.users[i]['Id']].push({'Users': response.data.users[i]});
				}
				//Build The Task Data
				for (var t in temp_data){
					var t_task = {
						'id' : t,
						'name' : temp_data[t][0].Users.FirstName + ' ' + temp_data[t][0].Users.LastName,
						'height' : '3em',
						'classes' : [],
						'tasks' : []
					};
					//Loop through data for activities
					for (var i = 0; i < temp_data[t].length; i++){
						var a = temp_data[t][i];
						if (a.StartDate){
							if (!a.StartTime){
								a.StartTime = '08:00';
							}
							a.StartDate = a.StartDate.split('T')[0];
							var appt_start = moment(a.StartDate).set('hour',a.StartTime.split(':')[0]).set('minute',a.StartTime.split(':')[1]);
							var appt_end = moment(a.StartDate).set('hour',a.StartTime.split(':')[0]).set('minute',a.StartTime.split(':')[1]).add(parseInt(a.DurationMinutes),'m');
							// console.log('SHOW START');
							// console.log(appt_start);
							// appt_start.hour(a.StartTime.split(':')[0]).minutes(a.StartTime.split(':')[1]);
							console.log(appt_start);
							// var appt_end = moment.utc(a.StartDate).hour(a.StartTime.split(':')[0]).minutes(a.StartTime.split(':')[1]).add(parseInt(a.DurationMinutes),'m');
							console.log(appt_end);
							t_task.tasks.push({
								'id' : a.Id,
								'name' : a.ActivityNumber,
								'from' : appt_start,
								'to' : appt_end,
								'class' : ''
							});
						}
					}
					Tasks.data.push(t_task);
				}
			}else{

			}
		});

		// Data
		vm.live = {};
		vm.options = {
			mode: 'custom',
			scale: '30 minutes',
			sortMode: undefined,
			sideMode: 'Tree',
			daily: false,
			maxHeight: false,
			width: false,
			zoom: 1,
			rowSortable: true,
			columns: ['model.name', 'from', 'to'],
			treeTableColumns: ['from', 'to'],
			columnsHeaders: {
				'model.name': 'Name',
				'from': 'Start Time',
				'to': 'End Time'
			},
			columnsClasses: {
				'model.name': 'gantt-column-name',
				'from': 'gantt-column-from',
				'to': 'gantt-column-to'
			},
			columnsFormatters: {
				'from': function(from) {
					return angular.isDefined(from) ? from.format('lll') : undefined;
				},
				'to': function(to) {
					return angular.isDefined(to) ? to.format('lll') : undefined;
				}
			},
			treeHeaderContent: '{{getHeader()}}',
			columnsHeaderContents: {
				'model.name': '{{getHeader()}}',
				'from': '{{getHeader()}}',
				'to': '{{getHeader()}}'
			},
			autoExpand: 'both',
			taskOutOfRange: 'truncate',
			fromDate: moment().hours(0).minutes(0),
			toDate: moment().add(1,'day').hours(0).minutes(0),
			rowContentEnabled: true,
			rowContent: '{{row.model.name}}',
			taskContentEnabled: true,
			taskContent: '<i ng-click="scope.vm.editDialog($event, \'task\', task)" class="gantt-task-edit-button icon-pencil s12 icon"\n   aria-label="edit task">\n</i>\n<span class="gantt-task-name">\n    {{task.model.name}}\n    <md-tooltip md-direction="top" class="gantt-chart-task-tooltip">\n        <div layout="column" layout-align="center center">\n            <div class="tooltip-name">\n                {{task.model.name}}\n            </div>\n            <div class="tooltip-date">\n                <span>\n                    {{task.model.from.format(\'MMM DD, HH:mm\')}}\n                </span>\n                <span>-</span>\n                <span>\n                    {{task.model.to.format(\'MMM DD, HH:mm\')}}\n                </span>\n            </div>\n        </div>\n    </md-tooltip>\n</span>',
			allowSideResizing: false,
			labelsEnabled: true,
			currentDate: 'line',
			currentDateValue: new Date(),
			draw: true,
			readOnly: false,
			groupDisplayMode: 'group',
			filterTask: '',
			filterRow: '',
			timeFrames: {

			},
			dateFrames: {

			},
			timeFramesWorkingMode: 'hidden',
			timeFramesNonWorkingMode: 'visible',
			columnMagnet: '15 minutes',
			timeFramesMagnet: false,
			dependencies: false,
			canDraw: function(event) {
				var isLeftMouseButton = event.button === 0 || event.button === 1;
				return vm.options.draw && !vm.options.readOnly && isLeftMouseButton;
			},
			drawTaskFactory: function() {
				return {
					id: ganttUtils.randomUuid(), // Unique id of the task.
					name: 'Drawn task', // Name shown on top of each task.
					color: '#AA8833' // Color of the task in HEX format (Optional).
				};
			},
			api: function(ganttApi) {
				// API Object is used to control methods and events from angular-gantt.
				vm.api = ganttApi;

				vm.api.core.on.ready($scope, function() {
					// When gantt is ready, load data.
					// `data` attribute could have been used too.
					vm.load();

					// DOM events
					vm.api.directives.on.new($scope, function(directiveName, directiveScope, element) {
						/**
						 * Gantt Task
						 */
						if (directiveName === 'ganttTask') {
							element.on('mousedown touchstart', function(event) {
								event.preventDefault();
								event.stopPropagation();
								vm.live.row = directiveScope.task.row.model;
								if (angular.isDefined(directiveScope.task.originalModel)) {
									vm.live.task = directiveScope.task.originalModel;
								} else {
									vm.live.task = directiveScope.task.model;
								}
								$scope.$digest();
							});
							element.on('dblclick taphold', function(event){
								//Load Activity Viewer Overlay
								console.log('ACTIVITY VIEW DISPLAYS');
							});
						}

						/**
						 * Gantt Row
						 */
						else if (directiveName === 'ganttRow') {

							element.on('click', function(event) {
								event.stopPropagation();
							});

							element.on('mousedown touchstart', function(event) {
								event.stopPropagation();
								vm.live.row = directiveScope.row.model;
								$scope.$digest();
							});

						}

						/**
						 * Gantt Row Label
						 */
						else if (directiveName === 'ganttRowLabel') {
							// Fix for double trigger due to gantt-sortable plugin
							element.off('click');

							element.on('click', function(event) {
								event.preventDefault();
								editDialog(event, 'row', directiveScope.row);
							});

							element.on('mousedown touchstart', function() {
								vm.live.row = directiveScope.row.model;
								$scope.$digest();
							});

						}
					});

					vm.api.tasks.on.rowChange($scope, function(task) {
						vm.live.row = task.row.model;
					});

					vm.api.tasks.on.change($scope, function(task){
						//get the updated start
						console.log(task);
						var startDate = task.model.from;
						console.log(startDate);
						console.log(startDate.toJSON());
						var startTime = task.model.from.hour() + ':' + task.model.from.minute();
						//get the duration
						var dur = task.model.to.diff(task.model.from,'minutes');
						DataSyncService.sync('saveActivity',
							{
								'Id': task.model.id,
								'StartDate': startDate,
								'StartTime': startTime,
								'DurationMinutes': dur,
								'TechId': task.row.model.id
							}, function(response){
							if (!response.success){
								toastr.error('Activity Failed To Save!','Uh Oh!');
							}
						});
					});

					objectModel = new GanttObjectModel(vm.api);
				});
			}
		};

		// Methods
		vm.toggleSidenav = toggleSidenav;
		vm.search = search;
		vm.setSortMode = setSortMode;
		vm.addDialog = addDialog;
		vm.editDialog = editDialog;
		vm.canAutoWidth = canAutoWidth;
		vm.getColumnWidth = getColumnWidth;
		vm.load = load;
		vm.reload = reload;

		//////////

		init();

		/**
		 * Initialize
		 */
		function init() {
			// Set Gantt Chart height at the init
			calculateHeight();

			angular.element($window).on('resize', function() {
				$scope.$apply(function() {
					calculateHeight();
				});
			});
		}

		/**
		 * Max Height Fix
		 */
		function calculateHeight() {
			vm.options.maxHeight = $document.find('#chart-container').offsetHeight;
		}

		/**
		 * Add New Row
		 */
		function addDialog(ev) {
			$mdDialog.show({
				controller: 'GanttChartAddEditDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/gantt-chart/dialogs/add-edit/add-dialog.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					dialogData: {
						chartData: vm.data,
						dialogType: 'add'
					}
				}
			});
		}

		/**
		 * Edit Dialog
		 */
		function editDialog(ev, formView, formData) {
			$mdDialog.show({
				controller: 'GanttActivityController',
				controllerAs: 'vm',
				templateUrl: 'app/main/gantt-chart/dialogs/add-edit/edit-dialog.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					dialogData: {
						chartData: vm.data,
						dialogType: 'edit',
						formView: formView,
						formData: formData
					}
				}
			});
		}

		/**
		 * Toggle sidenav
		 *
		 * @param sidenavId
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}

		/**
		 * Search
		 * @param sidenavId
		 */
		function search(option, keyword) {
			if (option === 'rows') {
				vm.options.filterRow = keyword;
			} else if (option === 'tasks') {
				vm.options.filterTask = keyword;
			}
		}

		/**
		 * Sort Mode
		 * @param mode
		 */
		function setSortMode(mode) {
			vm.options.sortMode = mode;

			if (angular.isUndefined(mode)) {
				vm.options.rowSortable = true;
			} else {
				vm.options.rowSortable = false;
			}
		}

		/**
		 * Side Mode
		 */
		$scope.$watch('vm.options.sideMode', function(newValue, oldValue) {
			if (newValue !== oldValue) {
				vm.api.side.setWidth(undefined);

				$timeout(function() {
					vm.api.columns.refresh();
				});
			}
		});

		function canAutoWidth(scale) {
			if (scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/)) {
				return false;
			}

			return true;
		}

		function getColumnWidth(widthEnabled, scale, zoom) {
			var x = 40 * zoom;
			if (!widthEnabled && vm.canAutoWidth(scale)) {
				x = undefined;
			}

			if (scale.match(/.*?week.*?/)) {
				x = 150 * zoom;
			}

			if (scale.match(/.*?month.*?/)) {
				x = 300 * zoom;
			}

			if (scale.match(/.*?quarter.*?/)) {
				x = 500 * zoom;
			}

			if (scale.match(/.*?year.*?/)) {
				x = 800 * zoom;
			}
			return x;
		}

		// Reload data action
		function load() {
			vm.data = Tasks.data;
			//vm.timespans = Timespans.data;

			// Fix for Angular-gantt-chart issue
			$animate.enabled(true);
			$animate.enabled($document.find('#gantt'), false);

		}

		/**
		 * Reload Data
		 */
		function reload() {
			msApi.resolve('ganttChart.tasks@get', function(response) {
				vm.data = response.data;
			});

			msApi.resolve('ganttChart.timespans@get', function(response) {
				vm.timespans = response.data;
			});
		}

		// Visual two way binding.
		var ganttDebounceValue = 1000;

		var listenTaskJson = ganttDebounce(function(taskJson) {
			if (angular.isDefined(taskJson)) {
				var task = angular.fromJson(taskJson);
				objectModel.cleanTask(task);
				var model = vm.live.task;
				angular.extend(model, task);
			}
		}, ganttDebounceValue);

		$scope.$watch('vm.live.taskJson', listenTaskJson);

		var listenRowJson = ganttDebounce(function(rowJson) {
			if (angular.isDefined(rowJson)) {
				var row = angular.fromJson(rowJson);
				objectModel.cleanRow(row);
				var tasks = row.tasks;

				delete row.tasks;
				var rowModel = vm.live.row;

				angular.extend(rowModel, row);

				var newTasks = {};
				var i, l;

				if (angular.isDefined(tasks)) {
					for (i = 0, l = tasks.length; i < l; i++) {
						objectModel.cleanTask(tasks[i]);
					}

					for (i = 0, l = tasks.length; i < l; i++) {
						newTasks[tasks[i].id] = tasks[i];
					}

					if (angular.isUndefined(rowModel.tasks)) {
						rowModel.tasks = [];
					}

					for (i = rowModel.tasks.length - 1; i >= 0; i--) {
						var existingTask = rowModel.tasks[i];
						var newTask = newTasks[existingTask.id];

						if (angular.isUndefined(newTask)) {
							rowModel.tasks.splice(i, 1);
						} else {
							objectModel.cleanTask(newTask);
							angular.extend(existingTask, newTask);

							delete newTasks[existingTask.id];
						}
					}
				} else {
					delete rowModel.tasks;
				}

				angular.forEach(newTasks, function(newTask) {
					rowModel.tasks.push(newTask);
				});
			}
		}, ganttDebounceValue);

		$scope.$watch('vm.live.rowJson', listenRowJson);

		$scope.$watchCollection('vm.live.task', function(task) {
			vm.live.taskJson = angular.toJson(task, true);
			vm.live.rowJson = angular.toJson(vm.live.row, true);
		});

		$scope.$watchCollection('vm.live.row', function(row) {
			vm.live.rowJson = angular.toJson(row, true);
			if (angular.isDefined(row) && angular.isDefined(row.tasks) && row.tasks.indexOf(vm.live.task) < 0) {
				vm.live.task = row.tasks[0];
			}
		});

		$scope.$watchCollection('vm.live.row.tasks', function() {
			vm.live.rowJson = angular.toJson(vm.live.row, true);
		});
	}

})();

(function() {
	'use strict';

	angular
		.module('app.dashboard', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.dashboard', {
				url: '/dashboard',
				views: {
					'content@app': {
						templateUrl: 'app/main/dashboard/dashboard.html',
						controller: 'DashboardController as vm'
					}
				},
				loginRequired: true
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/dashboard');

		// Navigation
		msNavigationServiceProvider.saveItem('fuse', {
			title: 'NAVIGATION',
			group: true,
			weight: 1
		});

		msNavigationServiceProvider.saveItem('fuse.dashboard', {
			title: 'Dashboard',
			icon: 'icon-tile-four',
			state: 'app.dashboard',
			/*stateParams: {
				'param1': 'page'
			 },*/
			translate: 'DASHBOARD.DASHBOARD_NAV',
			weight: 1
		});
	}
})();

(function() {
	'use strict';

	angular
		.module('app.dashboard')
		.controller('DashboardController', DashboardController);

	/** @ngInject */
	function DashboardController($rootScope, AuthenticationService, $window, DataSyncService, moment, $mdDialog, $mdpDatePicker, $mdpTimePicker) {
		var vm = this;

		// Data
		vm.currentUserSelected = 0;
		vm.currentExceptionUserSelected = 0;
		vm.currentTableData = [];
		vm.currentExceptionData = [];
		vm.userData = angular.copy($rootScope.activeUsers);
		vm.userObj = {};
		vm.dataByUser = {
			0:{
				regularHours: 0,
				breakHours: 0,
				otHours: 0,
				totalHours: 0
			}
		};
		vm.pieChart = '';
		vm.dtOptions = {
			dom: '<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			pagingType: 'simple',
			autoWidth: false,
			responsive: true,
			sort: false
		};
		vm.mWeekStart = moment().startOf('week').add(1,'day');
		vm.mWeekEnd = moment().endOf('week').add(1,'day');

		DataSyncService.getActiveUsers(function(data){
			var tdata = angular.copy(data);
			tdata.unshift({
				'Id':0,
				'FirstName':'All',
				'LastName':'Users'
			});
			vm.userData = tdata;
			for (var i = 0; vm.userData && i < vm.userData.length; i++){
				vm.userObj[vm.userData[i].Id] = vm.userData[i];
			}
		});
		DataSyncService.sync('getWeekLogData', {from: vm.mWeekStart.format('YYYY-MM-DD'), to:vm.mWeekEnd.format('YYYY-MM-DD')}, function(response) {
			if (response.success) {
				for (var i = 0; response.data && i < response.data.length; i++){
					if (!vm.dataByUser[response.data[i].UserId]){
						vm.dataByUser[response.data[i].UserId] = {'logs': []};
					}
					vm.dataByUser[response.data[i].UserId].logs.push(response.data[i]);
				}
				if (!vm.dataByUser[0]){
					vm.dataByUser[0] = {
						regularHours: 0,
						breakHours: 0,
						otHours: 0,
						totalHours: 0
					};
				}
				for (var u in vm.dataByUser){
					var d = DataSyncService.calculateTimeOverview(vm.dataByUser[u].logs);
					vm.dataByUser[u].regularHours = d.regHours || 0;
					vm.dataByUser[u].breakHours = d.breakHours || 0;
					vm.dataByUser[u].otHours = d.otHours || 0;
					vm.dataByUser[u].totalHours = d.totalHours || 0;
					vm.dataByUser[u].logs = d.logs;

					vm.dataByUser[0].regularHours += vm.dataByUser[u].regularHours;
					vm.dataByUser[0].breakHours += vm.dataByUser[u].breakHours;
					vm.dataByUser[0].otHours += vm.dataByUser[u].otHours;
					vm.dataByUser[0].totalHours += vm.dataByUser[u].totalHours;
				}
				vm.changeDataChart();
				vm.initChart(vm.dataByUser[0]);
			}
		});

		DataSyncService.sync('getOpenTimeLogExceptions', {}, function(response){
			if (response.success){
				vm.currentExceptionData = response.data;
			}
		});

		vm.updateExceptionStatus = function(exception, i){
			DataSyncService.sync('updateExceptionStatus',exception, function(response){
				if (response.success) {
					toastr.success('Exception Updated!', 'Success');
					var clear_exceptions = true;
					for (var i = 0; i < vm.currentExceptionData.length; i++){
						if (vm.currentExceptionData[i].Status == 'open'){
							clear_exceptions = false;
						}
					}
					if (clear_exceptions){
						vm.currentExceptionData = [];
					}
				} else {
					toastr.error('Exception Failed To Update!', 'Error');
				}
			});
		}

		vm.showTimePicker = function(ev, d, a) {
			var dd = moment().format('YYYY-MM-DD') + ' ' + d[a];
			var tempd = angular.copy(d);
			$mdpTimePicker(new Date(dd), {
				targetEvent: ev
			}).then(function(selectedDate) {
				if (a == 'LogFrom') {
					var sd = moment(selectedDate);
					var dt = moment(d.DateTime).hours(sd.hours()).minutes(sd.minutes());
					d['DateTime'] = dt.toDate();
					tempd['DateTime'] = dt.toJSON();
				}
				d[a] = moment(selectedDate).format('h:mm A');
				tempd[a] = moment(selectedDate).format('h:mm A');
				DataSyncService.sync('saveTimeLogAdmin', tempd, function(response) {
					if (response.success) {
						toastr.success('Time Log Successfully Updated!', 'Success');
					} else {
						toastr.error('Time Log Failed To Update!', 'Error');
					}
				});
			});
		}

		vm.displayLogMap = function(ev, log) {
			$mdDialog.show({
				locals: {
					log: log
				},
				controller: MapsDialogController,
				controllerAs: 'vm',
				templateUrl: 'app/main/time-management/time-management-map-dialog.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true
			});
		}

		vm.displayNote = function(ev, log) {
			$mdDialog.show({
				locals: {
					log: log
				},
				controller: NotesDialogController,
				controllerAs: 'vm',
				templateUrl: 'app/main/time-management/time-management-notes-dialog.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true
			}).then(function(resp) {
				log = resp;
				DataSyncService.sync('saveTimeLogAdmin', log, function(response) {
					if (response.success) {
						toastr.success('Notes Saved!', 'Success');
					} else {
						toastr.error('Notes Failed To Update!', 'Error');
					}
				});
			});
		}

		// Methods
		vm.initChart = function(dbu) {
			if (!dbu || !dbu.totalHours){
				dbu = {};
				dbu.regularHours = 0;
				dbu.breakHours = 0;
				dbu.otHours = 0
			}
			var chartObj = {
				options: {
					chart: {
						type: 'pieChart',
						height: 500,
						x: function(d) {
							return d.key;
						},
						y: function(d) {
							return d.y;
						},
						showLabels: true,
						transitionDuration: 500,
						labelThreshold: 0.01,
						legend: {
							margin: {
								top: 5,
								right: 35,
								bottom: 5,
								left: 0
							}
						}
					}
				},
				data: [{
					key: 'Regular',
					y: dbu.regularHours
				}, {
					key: 'Break',
					y: dbu.breakHours
				}, {
					key: 'Overtime',
					y: dbu.otHours
				}]
			}
			vm.pieChart = chartObj;
		};
		vm.onChartClick = function(data) {
			console.log(data);
		};
		vm.labelClick = function() {
			console.log('Label');
		};
		vm.changeDataChart = function() {
			if (vm.currentUserSelected == 0){
				var logs = [];
				for (var u in vm.dataByUser){
					if (vm.dataByUser[u].logs)
						logs = logs.concat(vm.dataByUser[u].logs);
				}
				vm.currentTableData = logs;
			}else{
				if (vm.dataByUser[vm.currentUserSelected]){
					vm.currentTableData = vm.dataByUser[vm.currentUserSelected].logs;
				}else{
					vm.currentTableData = [];
				}
			}
			vm.initChart(vm.dataByUser[vm.currentUserSelected]);
		};

		vm.changeExceptionData = function(){

		}
	}
	/** @ngInject */
	function NotesDialogController($mdDialog, log) {
		var vm = this;
		vm.log = log;

		vm.saveNotes = function() {
			$mdDialog.hide(vm.log);
		}

		vm.cancel = function() {
			$mdDialog.cancel();
		}
	}

	/** @ngInject */
	function MapsDialogController($mdDialog, log, uiGmapGoogleMapApi) {
		var vm = this;
		vm.log = log;
		vm.mapMarkers = [];


		uiGmapGoogleMapApi.then(function(maps) {
			if (!(vm.log instanceof Array)) {
				vm.log = [log];
			}
			for (var i = 0; i < vm.log.length; i++) {
				var icn = 'http://maps.google.com/mapfiles/ms/icons/green.png';
				if (vm.log[i].LogType == 'Clocked Out'){
					icn = 'http://maps.google.com/mapfiles/ms/icons/red.png';
				}
				if (vm.log[i].LogType == 'Went On Break'){
					icn = 'http://maps.google.com/mapfiles/ms/icons/yellow.png'
				}
				vm.mapMarkers.push({
					id: i,
					icon: icn,
					showWindow: false,
					title: 'My Marker',
					LogType: vm.log[i].LogType,
					LogFrom: vm.log[i].LogFrom,
					LogTo: vm.log[i].LogTo,
					DateTime: vm.log[i].DateTime,
					latitude: vm.log[i].Latitude,
					longitude: vm.log[i].Longitude
				});
			}
			console.log(vm.mapMarkers);
			vm.simpleMarkerMap = {
				center: {
					latitude: vm.mapMarkers[0].latitude,
					longitude: vm.mapMarkers[0].longitude
				},
				zoom: 8,
				markers: vm.mapMarkers
			};

			vm.customMarkerMap = {
				center: {
					latitude: -25.363882,
					longitude: 131.044922
				},
				zoom: 8,
				marker: {
					id: 0,
					coords: {
						latitude: -25.363882,
						longitude: 131.044922
					},
					options: {
						icon: {
							anchor: new maps.Point(36, 36),
							origin: new maps.Point(0, 0),
							url: '//google-developers.appspot.com/maps/documentation/javascript/examples/full/images/beachflag.png'
						}
					}
				}
			};

		});
		var onMarkerClicked = function(marker) {
			marker.showWindow = true;
		};

		_.each(vm.mapMarkers, function(marker) {
			marker.closeClick = function() {
				marker.showWindow = false;
				vm.$apply();
			};
			marker.onClicked = function() {
				onMarkerClicked(marker);
			};
		});

		vm.cancel = function() {
			$mdDialog.cancel();
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('app.activity', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.activity', {
				url: '/activity/:activityId',
				views: {
					'content@app': {
						templateUrl: 'app/main/activity/activity.html',
						controller: 'ActivityController as vm'
					}
				},
				loginRequired: true
			})
			.state('app.activity.new',{
				url: '/:jobId',
				views: {
					'content@app': {
						templateUrl: 'app/main/activity/activity.html',
						controller: 'ActivityController as vm'
					}
				},
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/activity');

		// // Navigation
		// msNavigationServiceProvider.saveItem('fuse', {
		// 	title: 'NODE',
		// 	group: true,
		// 	weight: 1
		// });

		// msNavigationServiceProvider.saveItem('fuse.dashboard', {
		// 	title: 'Dashboard',
		// 	icon: 'icon-tile-four',
		// 	state: 'app.dashboard',
		// 	/*stateParams: {
		// 		'param1': 'page'
		// 	 },*/
		// 	translate: 'DASHBOARD.DASHBOARD_NAV',
		// 	weight: 1
		// });
	}
})();

(function() {
	'use strict';

	angular
		.module('app.activity')
		.controller('ActivityController', ActivityController);

	/** @ngInject */
	function ActivityController($rootScope, AuthenticationService, DataSyncService, $stateParams, $location, $timeout, $mdDialog, moment, toastr) {
		var vm = this;
		vm.activityId = $stateParams.activityId;
		vm.currentActivityData = {};
		vm.activeUsers = [];

		DataSyncService.getActiveUsers(function(response){
			vm.activeUsers = response;
		});

		vm.qcImages = [];
		vm.swiperElem;

		if (vm.activityId != 'new'){
			DataSyncService.sync('getActivityData', {
				id: vm.activityId
			}, function(response) {
				if (response.success) {
					vm.currentActivityData = response.data;
					if (vm.currentActivityData.StartDate){
						vm.currentActivityData.StartDate = moment(response.data.StartDate.split('T')[0]).toDate();
					}
					var tm = response.data.StartTime;
					if (tm){
						tm = tm.split(":");
						vm.currentActivityData.StartTime = new Date(moment().hour(tm[0]).minute(tm[1]).second(0).format('M/DD/YY hh:mm A'));
					}else{
						vm.currentActivityData.StartTime = '';
					}
					vm.currentActivityData.DurationMinutes = parseInt(response.data.DurationMinutes);
					vm.currentActivityData.UnitCount = parseInt(response.data.UnitCount);
					for (var i = 0; response.data.QualityControl && i < response.data.QualityControl.length; i++) {
						var title = '';
						var txt = response.data.QualityControl[i].QcActivityNumber;
						for (var z = 0; response.data.QualityControl[i].Images && z < response.data.QualityControl[i].Images.length; z++) {
							vm.qcImages.push({
								'title': title,
								'text': txt,
								'media': {
									'image': {
										'src': response.data.QualityControl[i].Images[z].ImageUrl,
										'alt': txt + ' image ' + z
									}
								}
							});
						}
					}
					if (vm.swiperElem){
						vm.swiperElem.update();
					}
				} else {
					$location.path('/dashboard');
				}
			});
		}else{
			vm.currentActivityData.JobId = $stateParams.jobId;
		}

		$timeout(function() {
			if (vm.swiperElem){
				vm.swiperElem.update();
			}
		}, 1050);

		vm.initSwiper = function(swiper) {
			vm.swiperElem = swiper;
		};
		vm.onQcClick = function(qcImage, ev) {
			$mdDialog.show({
				controller: QCImageDialogController,
				templateUrl: '/app/main/activity/activity.qcimage.dialog.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					data: qcImage
				}
			});
		};
		vm.saveActivity = function(){
			var saveObject = angular.copy(vm.currentActivityData);
			if (saveObject.StartTime){
				saveObject.StartTime = moment(saveObject.StartTime).hours() + ':' + moment(saveObject.StartTime).minutes();
			}
			if (saveObject.StartDate){
				saveObject.StartDate = moment(saveObject.StartDate).add(moment().utcOffset()).toJSON();
			}
			DataSyncService.sync('saveActivity',saveObject,function(response){
				if (response.success){
					if (vm.activityId === 'new'){
						toastr.success('Activity Created!','Success!');
						$location.path('/activity/'+response.data.ActivityNumber);
					}else{
						toastr.success('Activity Updated!','Success!');
					}
				}else{
					toastr.error('Activity Failed To Update!','Uh Oh!');
				}
			});
		};

		vm.deleteActivity = function(){
			DataSyncService.sync('deleteActivity', vm.currentActivityData, function(response){
				if (response.success){
					toastr.success('Activity Deleted!','Success!');
					$location.path('/job/'+vm.currentActivityData['JobId']);
				}else{
					toastr.error('Activity Failed To Delete!','Uh Oh!');
				}
			});
		};
	}

	function QCImageDialogController(data, $mdDialog, $scope) {
		$scope.data = data;
		$scope.cancel = function(){
			$mdDialog.cancel();
		};
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function() {
	'use strict';
	angular
		.module('app.core')
		.directive('contenteditable', contentEditable);

	/** @ngInject */
	function contentEditable() {
		return {
			restrict: "A",
			require: "ngModel",
			link: function(scope, element, attrs, ngModel) {

				function read() {
					var html = element.html();
					html = html.replace(/&nbsp;/g, "\u00a0");
					ngModel.$setViewValue(html);
				}

				ngModel.$render = function() {
					element.html(ngModel.$viewValue || "");
				};

				element.bind("click", function() {
					console.log("CLICKED!");
				});

				element.bind("blur keyup change", function() {
					scope.$apply(read);
				});
			}
		};
	}
});
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $translate, $mdToast, AuthenticationService)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];
            vm.user = AuthenticationService.getCurrentUser();

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            'app.core',
            'app.navigation',
            'app.toolbar',
            'app.quick-panel',
            'app.login',
            'app.dashboard',
            'app.time-management',
            'app.user-settings',
            'app.time-schedule-settings',
            'app.route-tracking'
        ]);
})();

(function() {
	'use strict';

	angular
		.module('fuse')
		.controller('MainController', MainController);

	/** @ngInject */
	function MainController($scope, $rootScope) {
		// Data

		//////////

		// Remove the splash screen
		$scope.$on('$viewContentAnimationEnded', function(event) {
			if (event.targetScope.$id === $scope.$id) {
				$rootScope.$broadcast('msSplashScreen::remove');
			}
		});
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function() {
	'use strict';

	angular
		.module('app.core')
		.config(config);

	/** @ngInject */
	function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider, toastrConfig, uiGmapGoogleMapApiProvider) {
		// Enable debug logging
		$logProvider.debugEnabled(true);

		// toastr configuration
		toastr.options.timeOut = 3000;
		toastr.options.positionClass = 'toast-top-right';
		toastr.options.preventDuplicates = true;
		toastr.options.progressBar = true;

		// angular-translate configuration
		$translateProvider.useLoader('$translatePartialLoader', {
			urlTemplate: '{part}/i18n/{lang}.json'
		});
		$translateProvider.preferredLanguage('en');
		$translateProvider.useSanitizeValueStrategy('sanitize');

		/*eslint-disable */

		// ng-aria configuration
		$ariaProvider.config({
			tabindex: false
		});

		// uiGmapgoogle-maps configuration
		uiGmapGoogleMapApiProvider.configure({
		    key: 'AIzaSyD7i6sWHztX9bY2ff3iYmnK5ouEf4FHtsU',
		    v: '3.exp',
		    libraries: 'weather,geometry,visualization'
		});

		// Fuse theme configurations
		fuseConfigProvider.config({
			'disableCustomScrollbars': false,
			'disableCustomScrollbarsOnMobile': true,
			'disableMdInkRippleOnMobile': true
		});

		// msScroll configuration
		msScrollConfigProvider.config({
			wheelPropagation: true
		});

		// Toastr
		angular.extend(toastrConfig, {
			maxOpened: 3,
			newestOnTop: false,
			positionClass: 'toast-bottom-right',
			target: 'body'
		});

		/*eslint-enable */
	}
})();

(function() {
	'use strict';

	angular
		.module('fuse')
		.run(runBlock);

	/** @ngInject */
	function runBlock($rootScope, $timeout, $state, $location, AuthenticationService, DataSyncService) {
		// Activate loading indicator
		var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
			$rootScope.loadingProgress = true;
			if (toState.name != 'app.login') {
				AuthenticationService.VerifyLoggedIn(function(resp) {
					if (!resp.success) {
						$location.path('/login');
					}

				});
			}
		});
		// De-activate loading indicator
		var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function() {
			$timeout(function() {
				$rootScope.loadingProgress = false;
			});
		});

		// Store state in the root scope for easy access
		$rootScope.state = $state;

		// Cleanup
		$rootScope.$on('$destroy', function() {
			stateChangeStartEvent();
			stateChangeSuccessEvent();
		});
	}
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config()
    {
        // Put your custom configurations here
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function() {
	'use strict';

	angular
		.module('app.pages', [])
		.config(config);

	/** @ngInject */
	function config(msNavigationServiceProvider) {
		// Navigation
		// msNavigationServiceProvider.saveItem('pages', {
		// 	title: 'PAGES',
		// 	group: true,
		// 	weight: 2
		// });
	}
})();

(function() {
	'use strict';

	angular
		.module('app.gantt-chart', [
			'gantt',
			'gantt.sortable',
			'gantt.movable',
			'gantt.drawtask',
			'gantt.tooltips',
			'gantt.bounds',
			'gantt.progress',
			'gantt.table',
			'gantt.tree',
			'gantt.groups',
			'gantt.dependencies',
			'gantt.overlap',
			'ngAnimate',
			'gantt.resizeSensor'
		])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider) {
		$stateProvider.state('app.gantt-chart', {
			url: '/gantt-chart',
			views: {
				'content@app': {
					templateUrl: 'app/main/gantt-chart/gantt-chart.html',
					controller: 'GanttChartController as vm'
				}
			},
			// resolve: {
			// 	Tasks: function(msApi) {
			// 		return msApi.resolve('ganttChart.tasks@get');
			// 	},
			// 	Timespans: function(msApi) {
			// 		return msApi.resolve('ganttChart.timespans@get');
			// 	}
			// }
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/gantt-chart');

		// Navigation
		msNavigationServiceProvider.saveItem('gantt-chart', {
			title: 'Job Gantt',
			icon: 'icon-calendar-text',
			state: 'app.gantt-chart',
			weight: 1
		});

		// // Api
		// msApiProvider.register('ganttChart.tasks', ['http://www.dropapi.bosslync.com/jobs?gantt=true',{},{
		// 	'get' : {
		// 		'headers' : {
		// 			'Authorization' : $http.defaults.headers.common['Authorization']
		// 		}
		// 	}
		// }]);
		// msApiProvider.register('ganttChart.timespans', ['app/data/gantt-chart/timespans.json']);

	}

})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body>\n<md-content class=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/activity/activity.html","<div class=\"page-layout simple fullwidth\" id=\"page_activity\" ng-cloak><div class=\"header header-sm md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb mt-16\" layout=\"row\" layout-align=\"start center\"><a href=\"/dashboard\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon></a><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16\"></md-icon><a \nhref=\"/job/{{vm.currentActivityData.JobId}}\"><span class=\"parent\">JOB</span></a></div><div class=\"title\">\n{{vm.currentActivityData.ActivityNumber || \'New Activity\'}}</div><div class=\"md-subhead\">ACTIVITY DETAIL</div></div>\n<div layout=\"column\" layout-align=\"end\"><md-menu><md-button class=\"md-icon-button .md-background-fg\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon style=\"color:#fff\" md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"\" aria-label=\"Create QC\">Create QC\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"\" aria-label=\"Print Activity\">Print Activity</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteActivity()\" aria-label=\"Delete Activity\">Delete Activity\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\" md-background-bg><div \nlayout=\"row\" flex><ol class=\"progress\" \nng-class=\"{hold: vm.currentActivityData.Status == \'hold\', cancelled: vm.currentActivityData.Status == \'cancelled\'}\" \ndata-steps=\"4\"><li \nng-class=\"{done: [\'scheduled\',\'in progress\',\'hold\', \'complete\', \'cancelled\'].indexOf(vm.currentActivityData.Status) > -1, active: vm.currentActivityData.Status == \'open\'}\">\n<span class=\"name\">Open</span> <span class=\"step\"><span></span></span></li><li \nng-class=\"{done: [\'in progress\',\'hold\', \'complete\', \'cancelled\'].indexOf(vm.currentActivityData.Status) > -1, active: vm.currentActivityData.Status == \'scheduled\'}\">\n<span class=\"name\">Scheduled</span> <span class=\"step\"><span></span></span></li><li \nng-class=\"{done: [\'in progress\',\'hold\', \'complete\', \'cancelled\'].indexOf(vm.currentActivityData.Status) > -1, active: vm.currentActivityData.Status ==\'in progress\'}\">\n<span class=\"name\">In Progress</span> <span class=\"step\"><span></span></span></li><li \nng-class=\"{done: [\'hold\', \'complete\', \'cancelled\'].indexOf(vm.currentActivityData.Status) > -1}\"><span class=\"name\">\n{{((vm.currentActivityData.Status == \'hold\') ? \'Hold\' : ((vm.currentActivityData.Status == \'cancelled\') ? \'Cancelled\' : \'Complete\'))}}\n</span> <span class=\"step\"><span></span></span></li></ol></div><div class=\"widget-group\" layout=\"column\" flex=\"100\">\n<ms-widget layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><form ng-submit=\"vm.saveActivity()\" \nname=\"activityForm\" layout-gt-sm=\"row\" layout=\"column\" layout-wrap class=\"p-16\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"60\"><label>Assigned Technician</label><md-select ng-model=\"vm.currentActivityData.TechId\" name=\"tech_id\">\n<md-option ng-repeat=\"tech in vm.activeUsers\" value=\"{{tech.id}}\">{{tech.first_name + \' \' + tech.last_name}}\n</md-option></md-select></md-input-container><md-input-container class=\"\" flex-gt-sm=\"40\"><label>Activity Status\n</label><md-select ng-model=\"vm.currentActivityData.Status\" name=\"status\"><md-option \nng-repeat=\"status in [\'Open\',\'Scheduled\',\'In Progress\',\'Hold\',\'Complete\',\'Cancelled\']\" \nvalue=\"{{status.toLowerCase()}}\">{{status}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Scheduled Date</label><input type=\"date\" \nng-model=\"vm.currentActivityData.StartDate\" name=\"start_date\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Start Time</label><input type=\"time\" \nng-model=\"vm.currentActivityData.StartTime\" name=\"start_time\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Duration (Minutes)</label><input type=\"number\" \nng-model=\"vm.currentActivityData.DurationMinutes\" name=\"duration_minutes\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Units</label><input type=\"number\" ng-model=\"vm.currentActivityData.UnitCount\" \nname=\"unit_count\"></md-input-container><div flex=\"100\" layout=\"row\" layout-align=\"end\"><md-button type=\"submit\" \nclass=\"md-raised md-primary\">Save Changes</md-button></div></form></ms-widget-front></ms-widget></div><div \nclass=\"md-title mt-48\" ng-show=\"vm.qcImages.length\">QC Images</div><ks-swiper-container initial-slide=\"1\" loop=\"false\" \nshow-nav-buttons=\"false\" slides-per-view=\"4\" space-between=\"5\" pagination-clickable=\"false\" \non-ready=\"vm.initSwiper(swiper)\"><ks-swiper-slide class=\"swiper-slide\" ng-repeat=\"qcImage in vm.qcImages\"><ms-card \nng-click=\"vm.onQcClick(qcImage, $event)\" template=\"\'app/core/directives/ms-card/templates/template-4/template-4.html\'\" \nng-model=\"qcImage\"></ms-card></ks-swiper-slide></ks-swiper-container></div></div>");
$templateCache.put("app/main/activity/activity.qcimage.dialog.html","<md-dialog aria-label=\"QC image\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><img src=\"{{data.media.image.src}}\" \nstyle=\"width: 100%; height: auto\"></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/dashboard/dashboard.html","<div class=\"page-layout simple fullwidth\" id=\"dashboard\" ng-cloak><div class=\"header header-sm md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">Welcome!\n</div></div></div><div class=\"content\" md-background-bg><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"column\" flex=\"100\" ng-if=\"vm.currentExceptionData.length\"><div class=\"ph-8 pv-8 h1\">\nTime Log Exceptions</div></ms-widget><ms-widget layout=\"column\" flex=\"100\" ng-if=\"vm.currentExceptionData.length\">\n<ms-widget-front class=\"white-bg\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColDefs\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Exception</span></div></th><th \nclass=\"secondary-text\" ng-show=\"vm.currentExceptionUserSelected == 0\"><div class=\"table-header\"><span \nclass=\"column-title\">User</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">From</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">To</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Log Type</span></div></th><th class=\"secondary-text\">&nbsp;</th><th class=\"secondary-text\" \nng-show=\"vm.currentExceptionUserSelected == 0\">&nbsp;</th></tr></thead><tbody><tr \nng-repeat=\"l in vm.currentExceptionData\" ng-show=\"l.Status == \'open\'\"><td><md-select class=\"simplified\" \nng-model=\"l.Status\" ng-change=\"vm.updateExceptionStatus(l, $index)\" aria-label=\"Exception Action\"><md-option \nng-repeat=\"s in [{k:\'open\',v:\'Open\'},{k:\'closed\',v:\'Clear\'}]\" value=\"{{s.k}}\">{{s.v | uppercase}}</md-option>\n</md-select></td><td>{{l.ExceptionType}}</td><td ng-show=\"vm.currentExceptionUserSelected == 0\">\n{{vm.userObj[l.TimeLogs.UserId].FirstName + \' \' + vm.userObj[l.TimeLogs.UserId].LastName}}</td><td>\n{{l.TimeLogs.DateTime | date:\'MM/dd\' }}</td><td ng-click=\"vm.showTimePicker($event, l.TimeLogs, \'LogFrom\')\" \nng-model=\"l.TimeLogs.LogFrom\">{{l.TimeLogs.LogFrom}}</td><td ng-click=\"vm.showTimePicker($event, l.TimeLogs, \'LogTo\')\" \nng-model=\"l.TimeLogs.LogFrom\">{{l.TimeLogs.LogTo}}</td><td>{{l.TimeLogs.LogType}}</td><td><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"vm.displayNote($event, l.TimeLogs)\"><md-icon class=\"icon icon-forum s30\">\n</md-icon></md-button></td><td ng-show=\"vm.currentExceptionUserSelected == 0\"><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"vm.displayLogMap($event, l.TimeLogs)\"><md-icon \nclass=\"icon icon-map-marker-radius s30\"></md-icon></md-button></td></tr></tbody></table></div></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"100\"><div class=\"ph-8 pv-8 h1\">Overview For This Week</div></ms-widget>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"33\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-56 line-height-56\">{{vm.dataByUser[vm.currentUserSelected].regularHours}}</div><div \nclass=\"h3 secondary-text font-weight-500\">REG HOURS</div></div></ms-widget-front></ms-widget><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-56 line-height-56\">\n{{vm.dataByUser[vm.currentUserSelected].otHours}}</div><div class=\"h3 secondary-text font-weight-500\">OT HOURS</div>\n</div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-56 line-height-56\">{{vm.dataByUser[vm.currentUserSelected].breakHours}}</div><div \nclass=\"h3 secondary-text font-weight-500\">BREAK HOURS</div></div></ms-widget-front></ms-widget><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-56 line-height-56\">\n{{vm.dataByUser[vm.currentUserSelected].totalHours}}</div><div class=\"h3 secondary-text font-weight-500\">TOTAL HOURS\n</div></div></ms-widget-front></ms-widget></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"66\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<md-select class=\"simplified font-size-16\" ng-model=\"vm.currentUserSelected\" ng-change=\"vm.changeDataChart()\" \naria-label=\"Change User\"><md-option ng-repeat=\"t in vm.userData\" value=\"{{t.Id}}\">{{t.FirstName + \' \' + t.LastName}}\n</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"\" aria-label=\"Quick Export\">Quick Export</md-button></md-menu-item></md-menu-content></md-menu></div><nvd3 \noptions=\"vm.pieChart.options\" data=\"vm.pieChart.data\"></nvd3></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/job/job.html","<div class=\"page-layout simple fullwidth\" id=\"node\" ng-cloak><div class=\"header header-sm md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb mt-16\" \nlayout=\"row\" layout-align=\"start center\"><a href=\"/dashboard\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon>\n</a><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16\"></md-icon><a href=\"/node/{{vm.currentJobData.Node}}\"><span \nclass=\"parent\">NODE</span></a></div><div class=\"title\">{{vm.currentJobData.Address + \', \' + vm.currentJobData.Zip}}\n</div><div class=\"md-subhead\">JOB OVERVIEW</div></div><div layout=\"column\" layout-align=\"end\"><md-menu><md-button \nclass=\"md-icon-button .md-background-fg\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon style=\"color:#fff\" \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nhref=\"/job/{{vm.currentJobData.Id}}/edit\" aria-label=\"Edit Job\">Edit Job</md-button></md-menu-item><md-menu-item>\n<md-button href=\"/activity/new/{{vm.currentJobData.Id}}\" aria-label=\"Create Activity\">Create Activity</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"\" aria-label=\"Export Activities\">Export Activities</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"\" aria-label=\"Print Activities\">Print Activities</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\" md-background-bg><div class=\"widget-group\" \nlayout=\"column\" flex=\"100\"><ms-widget layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><table \nclass=\"dataTable row-border hover p-32\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColDefs\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Activity Number</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date Scheduled</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Duration (Minutes)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tech</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Units</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"activity in vm.currentJobData.Activities\"><td><a href=\"/activity/{{activity.ActivityNumber}}\">\n{{activity.ActivityNumber}}</a></td><td>{{activity.StartDate}}</td><td>{{activity.StartTime}}</td><td>\n{{activity.DurationMinutes}}</td><td>{{activity.Status}}</td><td>{{activity.TechId}}</td><td>{{activity.UnitCount}}\n</td></tr></tbody></table></ms-widget-front></ms-widget></div><div class=\"md-title mt-48\" ng-show=\"vm.qcImages.length\">\nQC Images</div><ks-swiper-container initial-slide=\"1\" loop=\"false\" show-nav-buttons=\"false\" slides-per-view=\"4\" \nspace-between=\"5\" pagination-clickable=\"false\" on-ready=\"vm.initSwiper(swiper)\"><ks-swiper-slide class=\"swiper-slide\" \nng-repeat=\"qcImage in vm.qcImages\"><ms-card ng-click=\"vm.onQcClick(qcImage, $event)\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-4/template-4.html\'\" ng-model=\"qcImage\"></ms-card>\n</ks-swiper-slide></ks-swiper-container></div></div>");
$templateCache.put("app/main/job/job.qcimage.dialog.html","<md-dialog aria-label=\"QC image\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><img src=\"{{data.media.image.src}}\" \nstyle=\"width: 100%; height: auto\"></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/job/job_edit.html","<div class=\"page-layout simple fullwidth\" id=\"node\"><div class=\"header header-sm md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{vm.currentJobData.Address + \', \' + vm.currentJobData.Zip}}</div><div class=\"md-subhead\">Edit Job</div></div></div>\n<div class=\"content\" md-background-bg><div class=\"widget-group\" layout=\"column\" flex=\"100\"><ms-widget layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"white-bg p-10\"><form ng-submit=\"vm.saveJob()\" layout=\"column\"><div flex=\"100\" \nlayout=\"row\"><md-input-container flex-gt-sm=\"20\"><label>Status</label><md-select ng-model=\"vm.currentJobData.Status\" \nname=\"status\"><md-option ng-repeat=\"s in [{v:\'active\',t:\'Active\'},{v:\'inactive\',t:\'Inactive\'}]\" value=\"{{s.v}}\">{{s.t}}\n</md-option></md-select></md-input-container></div><div flex=\"100\" layout=\"row\"><md-input-container flex-gt-sm=\"60\">\n<label>Address</label><input type=\"text\" ng-model=\"vm.currentJobData.Address\" name=\"address\"></md-input-container>\n<md-input-container flex-gt-sm=\"20\"><label>Zip Code</label><input type=\"text\" ng-model=\"vm.currentJobData.Zip\" \nname=\"zip\"></md-input-container></div><div flex=\"100\" layout=\"row\"><md-input-container flex-gt-sm=\"20\"><label>\n# Of Units</label><input type=\"number\" ng-model=\"vm.currentJobData.UnitCount\" name=\"unitcount\"></md-input-container>\n<md-input-container flex-gt-sm=\"20\"><label>Active Subscribers</label><input type=\"number\" \nng-model=\"vm.currentJobData.ActiveSubs\" name=\"activesubs\"></md-input-container><md-input-container flex-gt-sm=\"20\">\n<label>Target Start Date</label><input type=\"date\" ng-model=\"vm.currentJobData.TargetStart\" name=\"targetstart\">\n</md-input-container></div><div flex=\"100\" layout=\"row\"><md-input-container flex-gt-sm=\"20\"><label>Invoice Number\n</label><input type=\"text\" ng-model=\"vm.currentJobData.InvoiceNumber\" name=\"invoicenumber\"></md-input-container>\n<md-input-container flex-gt-sm=\"20\"><label>Invoice Amount</label><input type=\"text\" \nng-model=\"vm.currentJobData.InvoiceAmount\" name=\"invoiceamount\"></md-input-container></div><div flex=\"100\" \nlayout=\"row\" layout-align=\"end\"><md-button ng-click=\"vm.cancelEdit()\" class=\"md-raised md-warn\" \nstyle=\"margin-right:5px\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Save Changes\n</md-button></div></form></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" layout=\"row\" layout-align=\"start\"><div id=\"login-intro\" flex hide show-gt-sm><div class=\"logo\"><span>\n</span></div><div class=\"title\" translate=\"LOGIN.INTRO_TITLE\">Welcome to the TempLog!</div><div class=\"description\" \ntranslate=\"LOGIN.INTRO_DESCRIPTION\">\nWorkforce time tracking and time management should be as easy as a few clicks! TrybalTrack makes it all possible!</div>\n</div><div id=\"login-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div \nclass=\"logo\"><img src=\"/assets/images/logos/clock.png\"></div><div class=\"title\" translate=\"LOGIN.TITLE\">\nLog in to your account</div><form name=\"loginForm\" ng-submit=\"vm.submitLogin()\"><md-input-container class=\"md-block\" \nmd-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n<div ng-show=\"vm.loginFailure.error\" role=\"alert\" class=\"md-warn-fg\"><span translate=\"LOGIN.ERRORS.LOGIN_FAILURE\">\nLogin Failed! Either the email or password is incorrect!</span></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form></div></div></div>");
$templateCache.put("app/main/gantt-chart/gantt-chart.html","<div id=\"gantt-chart\" class=\"page-layout carded fullwidth\" \nng-class=\"{\'date-filter-active\':vm.dateFilterActive, \'search-active\': vm.searchActive}\" layout=\"row\"><md-sidenav \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" \nng-include=\"\'app/main/gantt-chart/sidenavs/settings/settings-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav>\n<div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\">\n<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-text\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text\" translate=\"GANTT.GANTT_CHART\">Gantt Chart</span></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchActive = !vm.searchActive\" \naria-label=\"Search\" translate translate-attr-aria-label=\"GANTT.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-tooltip><span translate=\"GANTT.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.dateFilterActive = !vm.dateFilterActive\" aria-label=\"Filter Date\" translate \ntranslate-attr-aria-label=\"GANTT.FILTER_DATE\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip><span \ntranslate=\"GANTT.FILTER_DATE\">Filter Date</span></md-tooltip></md-button><md-button ng-click=\"vm.reload()\" \nclass=\"md-icon-button\" aria-label=\"Reload\" translate translate-attr-aria-label=\"GANTT.RELOAD\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"GANTT.RELOAD\">RELOAD</span></md-tooltip></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" class=\"md-icon-button\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"GANTT.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span \ntranslate=\"GANTT.SETTINGS\">Settings</span></md-tooltip></md-button></div></div><div class=\"bottom\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><div class=\"search-boxes\" flex ng-show=\"vm.searchActive\" \nlayout=\"column\" layout-gt-xs=\"row\"><div class=\"search md-whiteframe-3dp mr-8\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchRowKeyword\" ng-change=\"vm.search(\'rows\', vm.searchRowKeyword)\" type=\"text\" \nplaceholder=\"Search in rows\" translate translate-attr-placeholder=\"GANTT.SEARCH_IN_ROWS\"></div><div \nclass=\"search md-whiteframe-3dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchTaskKeyword\" \nng-change=\"vm.search(\'tasks\', vm.searchTaskKeyword)\" type=\"text\" placeholder=\"Search in tasks\" translate \ntranslate-attr-placeholder=\"GANTT.SEARCH_IN_TASKS\"></div></div><div class=\"date-filter-box md-whiteframe-3dp\" \nng-show=\"vm.dateFilterActive\" layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"filter from\"><span class=\"label\">From:</span><md-datepicker ms-datepicker-fix \nng-model=\"vm.options.fromDate\" md-max-date=\"vm.options.toDate\" md-placeholder=\"Enter date\"></md-datepicker></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"filter to\"><span class=\"label\">To:</span><md-datepicker \nms-datepicker-fix ng-model=\"vm.options.toDate\" md-min-date=\"vm.options.fromDate\" md-placeholder=\"Enter date\">\n</md-datepicker></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.addDialog($event)\" class=\"md-icon-button add-row-button\" aria-label=\"Add\" translate \ntranslate-attr-aria-label=\"GANTT.ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"zoom\" layout=\"row\" layout-align=\"end center\"><span class=\"label\">Zoom:</span>\n<div class=\"input-wrapper\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \naria-label=\"minus\" ng-click=\"vm.options.zoom  = vm.options.zoom - 0.1\"><md-icon md-font-icon=\"icon-minus\"></md-icon>\n</md-button><input type=\"number\" ng-model=\"vm.options.zoom\" step=\"0.1\" min=\"0.1\" max=\"5\"><md-button \nclass=\"md-icon-button\" aria-label=\"plus\" ng-click=\"vm.options.zoom =vm.options.zoom + 0.1\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><md-select class=\"simplified select-scale\" \nng-model=\"vm.options.scale\" placeholder=\"Scale\"><md-option value=\"15 minutes\" translate=\"GANTT.15_MINUTES\">15 minutes\n</md-option><md-option value=\"30 minutes\" translate=\"GANTT.30_MINUTES\">30 minutes</md-option><md-option value=\"hour\" \ntranslate=\"GANTT.HOUR\">hour</md-option><md-option value=\"day\" translate=\"GANTT.DAY\">day</md-option><md-option \nvalue=\"week\" translate=\"GANTT.WEEK\">week</md-option><md-option value=\"2 weeks\" translate=\"GANTT.2_WEEKS\">2 weeks\n</md-option><md-option value=\"month\" translate=\"GANTT.MONTH\">month</md-option></md-select><div \nclass=\"divider-vertical\"></div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon md-font-icon=\"icon-sort\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"disabled\" \nng-click=\"vm.setSortMode(undefined)\" translate=\"GANTT.DISABLED\" translate-attr-aria-label=\"GANTT.DISABLED\">disabled\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"disabled\" ng-click=\"vm.setSortMode(\'from\')\" \ntranslate=\"GANTT.FROM\" translate-attr-aria-label=\"GANTT.FROM\">from</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(\'to\')\" translate=\"GANTT.TO\" translate-attr-aria-label=\"GANTT.TO\">to\n</md-button></md-menu-item><md-menu-item><md-button aria-label=\"disabled\" ng-click=\"vm.setSortMode(\'model.name\')\" \ntranslate=\"GANTT.NAME\" translate-attr-aria-label=\"GANTT.NAME\">name</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><md-content id=\"chart-container\" class=\"content\" flex layout=\"column\"><div flex layout-fill \nid=\"gantt\" gantt data=\"vm.data\" timespans=\"vm.timespans\" show-side=\"vm.options.labelsEnabled\" daily=\"vm.options.daily\" \nfilter-task=\"{\'name\': vm.options.filterTask}\" filter-row=\"{\'name\': vm.options.filterRow}\" \nsort-mode=\"vm.options.sortMode\" view-scale=\"vm.options.scale\" \ncolumn-width=\"vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)\" \nauto-expand=\"vm.options.autoExpand\" task-out-of-range=\"vm.options.taskOutOfRange\" from-date=\"vm.options.fromDate\" \nto-date=\"vm.options.toDate\" allow-side-resizing=\"vm.options.allowSideResizing\" \ntask-content=\"vm.options.taskContentEnabled ? vm.options.taskContent : undefined\" \nrow-content=\"vm.options.rowContentEnabled ? vm.options.rowContent : undefined\" current-date=\"vm.options.currentDate\" \ncurrent-date-value=\"vm.options.currentDateValue\" \nheaders=\"vm.options.width && vm.options.shortHeaders || vm.options.longHeaders\" max-height=\"vm.options.maxHeight\" \ntime-frames=\"vm.options.timeFrames\" date-frames=\"vm.options.dateFrames\" \ntime-frames-non-working-mode=\"vm.options.timeFramesNonWorkingMode\" time-frames-magnet=\"vm.options.timeFramesMagnet\" \napi=\"vm.options.api\" column-magnet=\"vm.options.columnMagnet\"><gantt-tree \nenabled=\"vm.options.sideMode === \'Tree\' || vm.options.sideMode === \'TreeTable\'\" \nheader-content=\"vm.options.treeHeaderContent\" keep-ancestor-on-filter-row=\"true\"></gantt-tree><gantt-table \nenabled=\"vm.options.sideMode === \'Table\' || vm.options.sideMode === \'TreeTable\'\" \ncolumns=\"vm.options.sideMode === \'TreeTable\' ? vm.options.treeTableColumns : vm.options.columns\" \nheaders=\"vm.options.columnsHeaders\" classes=\"vm.options.columnsClasses\" formatters=\"vm.options.columnsFormatters\" \ncontents=\"vm.options.columnsContents\" header-contents=\"vm.options.columnsHeaderContents\"></gantt-table><gantt-groups \nenabled=\"vm.options.groupDisplayMode === \'group\' || vm.options.groupDisplayMode === \'overview\' || vm.options.groupDisplayMode === \'promote\'\" \ndisplay=\"vm.options.groupDisplayMode\"></gantt-groups><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress>\n<gantt-sortable></gantt-sortable><gantt-movable enabled=\"!vm.options.readOnly\"></gantt-movable><gantt-draw-task \nenabled=\"vm.options.canDraw\" move-threshold=\"2\" task-factory=\"vm.options.drawTaskFactory\"></gantt-draw-task>\n<gantt-overlap></gantt-overlap><gantt-resize-sensor></gantt-resize-sensor></div></md-content></div></div></div>");
$templateCache.put("app/main/node/node.html","<div class=\"page-layout simple fullwidth\" id=\"node\"><div class=\"header header-sm md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{vm.currentNodeData.Name}}</div><div class=\"md-subhead\">NODE OVERVIEW</div></div><div layout=\"column\" \nlayout-align=\"end\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nstyle=\"color:#fff\" md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button href=\"node/{{vm.currentNodeData.Id}}/edit\" aria-label=\"Edit Node\">Edit Node</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"\" aria-label=\"Quick Export\">Quick Export</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"content\" md-background-bg><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.currentNodeSelected\" ng-change=\"vm.changeNodeChart()\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.nodeData\" value=\"{{key}}\">{{range.Name}}</md-option></md-select><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button href=\"/node/{{vm.currentNodeData.Id}}\" \naria-label=\"Open Node\">View Node</md-button></md-menu-item><md-menu-item><md-button ng-click=\"\" \naria-label=\"Quick Export\">Quick Export</md-button></md-menu-item></md-menu-content></md-menu></div><div \nlayout=\"column\" flex=\"100\" layout-wrap><div class=\"pt-8 pb-32\" layout=\"column\" flex=\"100\" layout-align=\"center center\">\n<div class=\"light-blue-fg font-size-72 line-height-72\">25%</div><div class=\"h3 secondary-text font-weight-500\">\nCONVERSION RATE</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" flex=\"100\" layout-align=\"start center\">\n<span class=\"h4 secondary-text text-truncate\">Test: </span><span class=\"h4 ml-8\">21</span></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"column\" flex=\"100\"><ms-widget layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"><table class=\"dataTable row-border hover p-32\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Street</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Units</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Pen.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Rpt.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Disc.</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">TC</span></div></th></tr></thead><tbody><tr \nng-repeat=\"job in vm.currentNodeData.Jobs\"><td><a href=\"/job/{{job.Id}}\">{{job.Address}}</a></td><td>{{job.UnitCount}}\n</td><td>{{job.Penetration}}%</td><td>{{job.RepeatRate}}%</td><td>{{job.DiscoRate}}%</td><td>{{job.TcRate}}%</td></tr>\n</tbody></table></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/node/node_edit.html","<div class=\"page-layout simple fullwidth\" id=\"node\"><div class=\"header header-sm md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{vm.currentNodeData.Name}}</div><div class=\"md-subhead\">Edit Node</div></div></div><div class=\"content\" \nmd-background-bg><div class=\"widget-group\" layout=\"column\" flex=\"100\"><ms-widget layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"white-bg p-10\"><form ng-submit=\"vm.saveNode()\" layout=\"column\"><div flex=\"100\" layout=\"row\">\n<md-input-container flex-gt-sm=\"20\"><label>Status</label><md-select ng-model=\"vm.currentNodeData.Status\" name=\"status\">\n<md-option ng-repeat=\"s in [{v:\'active\',t:\'Active\'},{v:\'inactive\',t:\'Inactive\'}]\" value=\"{{s.v}}\">{{s.t}}</md-option>\n</md-select></md-input-container><md-input-container flex-gt-sm=\"60\"><label>Name</label><input type=\"text\" \nng-model=\"vm.currentNodeData.Name\" name=\"name\"></md-input-container></div><div flex=\"100\" layout=\"row\" \nlayout-align=\"end\"><md-button ng-click=\"vm.cancelEdit()\" class=\"md-raised md-warn mr-8\" style=\"margin-right:5px\">Cancel\n</md-button><md-button type=\"submit\" class=\"md-raised md-primary\">Save Changes</md-button></div></form>\n</ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/route-tracking/route-tracking.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><span class=\"h2 white-fg\">Route Tracking</span></div><div class=\"content-card\">\n<div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" flex layout-align=\"start center\">\n<md-select class=\"simplified font-size-16\" ng-model=\"vm.currentUserSelected\" ng-change=\"vm.loadGPSDataByUser()\" \naria-label=\"Change User\"><md-option ng-repeat=\"t in vm.userData\" value=\"{{t.Id}}\">{{t.FirstName + \' \' + t.LastName}}\n</md-option></md-select></div><div layout=\"row\" flex layout-align=\"end center\"><div class=\"date-filter-box\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"filter from\"><span class=\"label\">From:</span><md-datepicker ng-change=\"vm.init()\" ms-datepicker-fix \nng-model=\"vm.mWeekStart\" md-placeholder=\"Enter date\"></md-datepicker></div><div layout=\"row\" style=\"margin-left: 15px\" \nlayout-align=\"center center\" class=\"filter to\"><span class=\"label\">To:</span><md-datepicker ng-change=\"vm.init()\" \nms-datepicker-fix ng-model=\"vm.mWeekEnd\" md-placeholder=\"Enter date\"></md-datepicker></div></div></div></div>\n<md-content class=\"content\" ms-scroll><div style=\"min-width:100%; height: 800px; max-height:800px; overflow: hidden\">\n<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-markers \nmodels=\"vm.simpleMarkerMap.markers\" coords=\"\'self\'\" icon=\"\'icon\'\"><ui-gmap-windows show=\"\'showWindow\'\" \ncloseclick=\"\'closeClick\'\" ng-cloak><div><h3 ng-non-bindable>{{user}}</h3><h3 ng-non-bindable>{{LogType}}</h3><p \nng-non-bindable>Logged On {{DateTime | date:\"M/dd/y\"}} @ {{LogFrom}}</p></div></ui-gmap-windows></ui-gmap-markers>\n</ui-gmap-google-map></div></md-content></div></div></div>");
$templateCache.put("app/main/time-management/time-management-map-dialog.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Time Log Map</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"min-width:800px; max-width:800px;max-height:810px\">\n<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-markers \nmodels=\"vm.simpleMarkerMap.markers\" coords=\"\'self\'\" icon=\"\'icon\'\"><ui-gmap-windows show=\"\'showWindow\'\" \ncloseclick=\"\'closeClick\'\" ng-cloak><div><h3 ng-non-bindable>{{LogType}}</h3><p ng-non-bindable>\nLogged On {{DateTime | date:\"M/dd/y\"}} @ {{LogFrom}}</p></div></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/time-management/time-management-notes-dialog.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Time Log Notes</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"min-width:500px; max-width:800px;max-height:810px\">\n<md-input-container class=\"md-block\"><label>Notes</label><textarea ng-model=\"vm.log.Notes\" rows=\"5\"></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.saveNotes()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/time-management/time-management.html","<div class=\"page-layout simple fullwidth\" id=\"time-management\" ng-cloak><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"header\" layout=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\">\n<md-icon md-font-icon=\"icon-calendar-clock\" class=\"icon\"></md-icon></span><span class=\"logo-text\">Time Management\n</span></div><div class=\"bottom\" layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end end\"><div \nclass=\"date-filter-box md-whiteframe-3dp\" layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\"><div \nlayout=\"row\" layout-align=\"center center\" class=\"filter from\"><span class=\"label\">From:</span><md-datepicker \nng-change=\"vm.init()\" ms-datepicker-fix ng-model=\"vm.mWeekStart\" md-placeholder=\"Enter date\"></md-datepicker></div><div\n layout=\"row\" layout-align=\"center center\" class=\"filter to\"><span class=\"label\">To:</span><md-datepicker \nng-change=\"vm.init()\" ms-datepicker-fix ng-model=\"vm.mWeekEnd\" md-placeholder=\"Enter date\"></md-datepicker></div></div>\n</div></div><div class=\"content\" md-background-bg><ms-widget layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select \nclass=\"simplified font-size-16\" ng-model=\"vm.currentUserSelected\" ng-change=\"vm.changeDataChart()\" \naria-label=\"Change User\"><md-option ng-repeat=\"t in vm.userData\" value=\"{{t.Id}}\">{{t.FirstName + \' \' + t.LastName}}\n</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"\" aria-label=\"Quick Export\">Quick Export</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.viewAllOnMap($event)\" aria-label=\"Quick Export\">View All On Map</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColDefs\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\" ng-show=\"vm.currentUserSelected == 0\"><div class=\"table-header\"><span class=\"column-title\">User\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">From</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">To</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Hours</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Regular</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Overtime</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Log Type</span></div></th><th \nclass=\"secondary-text\">&nbsp;</th><th class=\"secondary-text\" ng-show=\"vm.currentUserSelected == 0\">&nbsp;</th></tr>\n</thead><tbody><tr ng-class=\"{success: l.Status == \'approved\', danger: l.Status == \'denied\'}\" \nng-repeat=\"l in vm.currentTableData\"><td><md-select class=\"simplified\" ng-model=\"l.Status\" \nng-change=\"vm.updateLogStatus(l)\" aria-label=\"Time Log Status\"><md-option \nng-repeat=\"s in [\'pending\',\'approved\',\'denied\']\" value=\"{{s}}\">{{s | uppercase}}</md-option></md-select></td><td \nng-show=\"vm.currentUserSelected == 0\">{{vm.userObj[l.UserId].FirstName + \' \' + vm.userObj[l.UserId].LastName}}</td><td>\n{{l.DateTime | date:\'MM/dd\' }}</td><td ng-click=\"vm.showTimePicker($event, l, \'LogFrom\')\" ng-model=\"l.LogFrom\">\n{{l.LogFrom}}</td><td ng-click=\"vm.showTimePicker($event, l, \'LogTo\')\" ng-model=\"l.LogFrom\">{{l.LogTo}}</td><td>\n{{l.hours}}</td><td>{{l.regHours}}</td><td>{{l.otHours}}</td><td>{{l.LogType}}</td><td><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"Favorite\" ng-click=\"vm.displayNote($event, l)\"><md-icon \nclass=\"icon icon-forum s30\"></md-icon></md-button></td><td ng-show=\"vm.currentUserSelected == 0\"><md-button \nclass=\"md-icon-button md-accent\" aria-label=\"Favorite\" ng-click=\"vm.displayLogMap($event, l)\"><md-icon \nclass=\"icon icon-map-marker-radius s30\"></md-icon></md-button></td></tr></tbody></table></div></div></ms-widget-front>\n</ms-widget></div></div>");
$templateCache.put("app/main/time-schedule-settings/time-schedule-settings-delete-dialog.html","<md-dialog><md-toolbar><div class=\"md-toolbar-tools\"><h2>Replace Schedule With....</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"min-width:500px; max-width:800px;max-height:810px\"><label>\nTime Schedule</label><md-select name=\"timeschedule\" ng-model=\"vm.selectedSchedule\" placeholder=\"Time Schedule\" \nrequired><md-option ng-repeat=\"tsched in vm.timeSchedules\" value=\"{{tsched.Id}}\">{{tsched.Name}}</md-option>\n</md-select></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.confirmDelete()\">Swap &amp; Delete</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/time-schedule-settings/time-schedule-settings.html","<div id=\"time-schedule-settings\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\"><div class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/time-schedule-settings/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"!vm.selectedSchedule\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s128 md-accent\" md-font-icon=\"icon-alarm-multiple\"></md-icon>\n</div><span class=\"app-title\">Time Schedules</span> <span class=\"hide show-gt-md secondary-text\">\nSelect a time schedule to edit the settings!..</span><md-button class=\"md-raised hide-gt-md\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\">Select a time schedule to edit the settings!..</md-button></div><div \nng-if=\"vm.selectedSchedule\" class=\"chat\" layout=\"column\" flex><md-toolbar class=\"chat-toolbar\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-alarm-multiple s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.toggleSidenav(\'right-sidenav\')\"><div class=\"chat-contact-name\">\n{{vm.selectedSchedule.Name}}</div></div><md-menu md-position-mode=\"target-right target\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.deleteTimeSchedule($event)\">\nDelete Schedule</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-content id=\"chat-content\" \nflex ms-scroll><div style=\"padding:10px\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form \nname=\"timeCardForm\" ng-submit=\"vm.saveTimeSchedule()\" class=\"md-inline-form\" novalidate><div class=\"form-title\">\nTime Schedule Settings</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"name\" ng-model=\"vm.selectedSchedule.Name\" placeholder=\"Time Schedule Name\" required><div \nng-messages=\"timeCardForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required.</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nOT Calculated By</label><md-select name=\"userstatus\" ng-model=\"vm.selectedSchedule.OtType\" \nplaceholder=\"OT Calculated By\"><md-option ng-repeat=\"o in [{k:\'day\',v:\'Hours In Day\'},{k:\'week\',v:\'Hours In Week\'}]\" \nvalue=\"{{o.k}}\">{{o.v}}</md-option></md-select></md-input-container><md-input-container flex><input type=\"text\" \nname=\"otmin\" ng-model=\"vm.selectedSchedule.OtMin\" placeholder=\"Minutes Worked Before OT Starts\" required><div \nng-messages=\"timeCardForm.otmin.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMinutes Worked Before OT Starts field is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><div flex-xs flex=\"50\"><md-checkbox aria-label=\"Select All\" \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAllCheckboxes()\"><span \nng-if=\"vm.isChecked()\">Un-</span>Select All</md-checkbox></div><div class=\"checkbox-list\" flex=\"100\" \nng-repeat=\"item in vm.timeSheetDays\"><div layout=\"row\"><div flex=\"20\"><md-checkbox ng-checked=\"vm.exists(item)\" \nng-click=\"vm.toggleCheckbox(item)\"><div layout=\"row\">{{ item }}</div></md-checkbox></div><div \nclass=\"timesheet-timepickers\" flex=\"80\" ng-if=\"vm.selectedSchedule.ScheduleData[item].Selected\"><md-input-container \nflex><input type=\"text\" ng-model=\"vm.selectedSchedule.ScheduleData[item].StartTime\" \nng-click=\"vm.showTimePicker($event, item, \'StartTime\')\" placeholder=\"Start Time\"></md-input-container>\n<md-input-container flex><input type=\"text\" ng-model=\"vm.selectedSchedule.ScheduleData[item].EndTime\" \nng-click=\"vm.showTimePicker($event, item, \'EndTime\')\" placeholder=\"End Time\"></md-input-container><md-input-container \nflex><label>Modifier</label><md-select ng-model=\"vm.selectedSchedule.ScheduleData[item].Modifier\" \nplaceholder=\"Modifier\"><md-option \nng-repeat=\"o in [{k:\'1\',v:\'None\'},{k:\'1.5\',v:\'Time And A Half\'},{k:\'2\',v:\'Double Time\'}]\" value=\"{{o.k}}\">{{o.v}}\n</md-option></md-select></md-input-container></div></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent pull-right\" aria-label=\"Submit\" ng-disabled=\"timeCardForm.$invalid\">Save Time Schedule\n</md-button></form></div></div></md-content></div></div></div></div>");
$templateCache.put("app/main/user-settings/user-settings.html","<div id=\"user-settings\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\"><div class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/user-settings/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"!vm.selectedUser\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s128 md-accent\" md-font-icon=\"icon-people\"></md-icon></div><span \nclass=\"app-title\">User Settings</span> <span class=\"hide show-gt-md secondary-text\">\nSelect a user to edit their settings!..</span><md-button class=\"md-raised hide-gt-md\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\">Select a user to edit their settings!..</md-button></div><div \nng-if=\"vm.selectedUser\" class=\"chat\" layout=\"column\" flex><md-toolbar class=\"chat-toolbar\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-people s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.toggleSidenav(\'right-sidenav\')\"><div class=\"avatar-wrapper\"><img \nsrc=\"assets/images/avatars/profile.jpg\" class=\"avatar\" \nalt=\"{{vm.selectedUser.FirstName + \' \' + vm.selectedUser.LastName}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"vm.contacts.getById(vm.chatContactId).status\"></i></div><div class=\"chat-contact-name\">\n{{vm.selectedUser.FirstName + \' \' + vm.selectedUser.LastName}} <span ng-if=\"vm.selectedUser.EmployeeId\">\n({{vm.selectedUser.EmployeeId}})</span></div></div><md-menu md-position-mode=\"target-right target\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.pingUserLocation()\">Ping User Location\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteUser()\">Delete User</md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content id=\"chat-content\" flex ms-scroll><div \nstyle=\"min-width:100%; height: 200px; max-height:200px; overflow: hidden\" ng-if=\"!vm.isNewUser\"><ui-gmap-google-map \ncenter=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-markers models=\"vm.simpleMarkerMap.markers\" \ncoords=\"\'self\'\" icon=\"\'icon\'\"><ui-gmap-windows show=\"\'showWindow\'\" closeclick=\"\'closeClick\'\" ng-cloak><div><h3 \nng-non-bindable>{{LogType}}</h3><p ng-non-bindable>Logged On {{DateTime | date:\"M/dd/y\"}} @ {{LogFrom}}</p></div>\n</ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div><div style=\"padding:10px\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" style=\"margin-bottom:10px\"><form name=\"basicForm\" \nng-submit=\"vm.saveUser()\" class=\"md-inline-form\" novalidate><div class=\"form-title\">User Details</div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>User Status</label><md-select name=\"userstatus\" \nng-model=\"vm.selectedUser.Status\" placeholder=\"Account Status\"><md-option \nng-repeat=\"o in [{k:\'active\',v:\'Active\'},{k:\'inactive\',v:\'Inactive\'}]\" value=\"{{o.k}}\">{{o.v}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Access Level</label><md-select name=\"accesslevel\" \nng-model=\"vm.selectedUser.AccessLevel\" placeholder=\"Access Level\"><md-option \nng-repeat=\"o in [{k:1,v:\'Administrator\'},{k:2,v:\'Supervisor\'},{k:3,v:\'User\'}]\" value=\"{{o.k}}\">{{o.v}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input \ntype=\"text\" name=\"firstname\" ng-model=\"vm.selectedUser.FirstName\" placeholder=\"First Name\" required><div \nng-messages=\"basicForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\"><span>First Name field is required.\n</span></div></div></md-input-container><md-input-container flex><input type=\"text\" name=\"lastname\" \nng-model=\"vm.selectedUser.LastName\" placeholder=\"Last Name\" required><div ng-messages=\"basicForm.lastname.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Last Name field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"employeeid\" \nng-model=\"vm.selectedUser.EmployeeId\" placeholder=\"Employee Id\" required><div \nng-messages=\"basicForm.employeeid.$error\" role=\"alert\"><div ng-message=\"required\"><span>Employee Id field is required.\n</span></div></div></md-input-container><md-input-container flex><label>Time Schedule</label><md-select \nname=\"timeschedule\" ng-model=\"vm.selectedUser.TimeSchedule\" placeholder=\"Time Schedule\" required><md-option \nng-repeat=\"tsched in vm.timeSchedules\" value=\"{{tsched.Id}}\">{{tsched.Name}}</md-option></md-select><div \nng-messages=\"basicForm.timeschedule.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTime Schedule field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><input type=\"text\" name=\"emailaddress\" ng-model=\"vm.selectedUser.EmailAddress\" \nplaceholder=\"Email Address\" required><div ng-messages=\"basicForm.emailaddress.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Email Address field is required.</span></div></div></md-input-container><md-input-container\n flex><label>Supervisor</label><md-select name=\"supervisor\" ng-model=\"vm.selectedUser.SupervisorId\" \nplaceholder=\"Supervisor\"><md-option ng-repeat=\"sup in vm.supervisorList\" value=\"{{sup.Id}}\">\n{{sup.FirstName + \' \' + sup.LastName}}<span ng-if=\"sup.EmployeeId\"> ({{sup.EmployeeId}})</span></md-option></md-select>\n</md-input-container></div><md-button ng-if=\"!vm.isNewUser\" class=\"md-raised md-accent md-hue-1\" \nng-click=\"vm.resetPassword()\">Reset Password</md-button><md-button ng-if=\"!vm.isNewUser\" class=\"md-raised md-primary\" \nng-click=\"vm.unlockDevice()\">Unlock Device</md-button><md-button type=\"submit\" class=\"md-raised md-accent pull-right\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Save User</md-button></form></div></div>\n</md-content></div></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/main/activity/dialogs/add.activity.html","");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img src=\"/assets/images/logos/clock.png\" \nstyle=\"width:48px; height: 48px; min-width: 48px; margin-left: -9px\"> <span class=\"logo-text\">TrybalTrack</span></div>\n<md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar>\n</ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" \nlayout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-xs>{{vm.user.first_name + \' \' + vm.user.last_name}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/gantt-chart/dialogs/activity/activity.html","<div class=\"page-layout simple fullwidth\" id=\"page_activity\" ng-cloak><div class=\"header header-sm md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb mt-16\" layout=\"row\" layout-align=\"start center\"><a href=\"/dashboard\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon></a><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16\"></md-icon><a \nhref=\"/job/{{vm.currentActivityData.JobId}}\"><span class=\"parent\">JOB</span></a></div><div class=\"title\">\n{{vm.currentActivityData.ActivityNumber || \'New Activity\'}}</div><div class=\"md-subhead\">ACTIVITY DETAIL</div></div>\n<div layout=\"column\" layout-align=\"end\"><md-menu><md-button class=\"md-icon-button .md-background-fg\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon style=\"color:#fff\" md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"\" aria-label=\"Create QC\">Create QC\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"\" aria-label=\"Print Activity\">Print Activity</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteActivity()\" aria-label=\"Delete Activity\">Delete Activity\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\" md-background-bg><div \nlayout=\"row\" flex><ol class=\"progress\" \nng-class=\"{hold: vm.currentActivityData.Status == \'hold\', cancelled: vm.currentActivityData.Status == \'cancelled\'}\" \ndata-steps=\"4\"><li \nng-class=\"{done: [\'scheduled\',\'in progress\',\'hold\', \'complete\', \'cancelled\'].indexOf(vm.currentActivityData.Status) > -1, active: vm.currentActivityData.Status == \'open\'}\">\n<span class=\"name\">Open</span> <span class=\"step\"><span></span></span></li><li \nng-class=\"{done: [\'in progress\',\'hold\', \'complete\', \'cancelled\'].indexOf(vm.currentActivityData.Status) > -1, active: vm.currentActivityData.Status == \'scheduled\'}\">\n<span class=\"name\">Scheduled</span> <span class=\"step\"><span></span></span></li><li \nng-class=\"{done: [\'in progress\',\'hold\', \'complete\', \'cancelled\'].indexOf(vm.currentActivityData.Status) > -1, active: vm.currentActivityData.Status ==\'in progress\'}\">\n<span class=\"name\">In Progress</span> <span class=\"step\"><span></span></span></li><li \nng-class=\"{done: [\'hold\', \'complete\', \'cancelled\'].indexOf(vm.currentActivityData.Status) > -1}\"><span class=\"name\">\n{{((vm.currentActivityData.Status == \'hold\') ? \'Hold\' : ((vm.currentActivityData.Status == \'cancelled\') ? \'Cancelled\' : \'Complete\'))}}\n</span> <span class=\"step\"><span></span></span></li></ol></div><div class=\"widget-group\" layout=\"column\" flex=\"100\">\n<ms-widget layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><form ng-submit=\"vm.saveActivity()\" \nname=\"activityForm\" layout-gt-sm=\"row\" layout=\"column\" layout-wrap class=\"p-16\"><md-input-container class=\"md-block\" \nflex-gt-sm=\"60\"><label>Assigned Technician</label><md-select ng-model=\"vm.currentActivityData.TechId\" name=\"tech_id\">\n<md-option ng-repeat=\"tech in vm.activeUsers\" value=\"{{tech.id}}\">{{tech.first_name + \' \' + tech.last_name}}\n</md-option></md-select></md-input-container><md-input-container class=\"\" flex-gt-sm=\"40\"><label>Activity Status\n</label><md-select ng-model=\"vm.currentActivityData.Status\" name=\"status\"><md-option \nng-repeat=\"status in [\'Open\',\'Scheduled\',\'In Progress\',\'Hold\',\'Complete\',\'Cancelled\']\" \nvalue=\"{{status.toLowerCase()}}\">{{status}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Scheduled Date</label><input type=\"date\" \nng-model=\"vm.currentActivityData.StartDate\" name=\"start_date\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Start Time</label><input type=\"time\" \nng-model=\"vm.currentActivityData.StartTime\" name=\"start_time\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Duration (Minutes)</label><input type=\"number\" \nng-model=\"vm.currentActivityData.DurationMinutes\" name=\"duration_minutes\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"25\"><label>Units</label><input type=\"number\" ng-model=\"vm.currentActivityData.UnitCount\" \nname=\"unit_count\"></md-input-container><div flex=\"100\" layout=\"row\" layout-align=\"end\"><md-button type=\"submit\" \nclass=\"md-raised md-primary\">Save Changes</md-button></div></form></ms-widget-front></ms-widget></div><div \nclass=\"md-title mt-48\" ng-show=\"vm.qcImages.length\">QC Images</div><ks-swiper-container initial-slide=\"1\" loop=\"false\" \nshow-nav-buttons=\"false\" slides-per-view=\"4\" space-between=\"5\" pagination-clickable=\"false\" \non-ready=\"vm.initSwiper(swiper)\"><ks-swiper-slide class=\"swiper-slide\" ng-repeat=\"qcImage in vm.qcImages\"><ms-card \nng-click=\"vm.onQcClick(qcImage, $event)\" template=\"\'app/core/directives/ms-card/templates/template-4/template-4.html\'\" \nng-model=\"qcImage\"></ms-card></ks-swiper-slide></ks-swiper-container></div></div>");
$templateCache.put("app/main/gantt-chart/dialogs/activity/activity.qcimage.dialog.html","<md-dialog aria-label=\"QC image\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><img src=\"{{data.media.image.src}}\" \nstyle=\"width: 100%; height: auto\"></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/gantt-chart/dialogs/add-edit/add-dialog.html","<md-dialog flex-gt-sm=\"80\" class=\"gantt-chart-add-edit-dialog\" aria-label=\"Add Dialog\" ng-cloak><md-toolbar \nclass=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Add\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon\n md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"GANTT.ADD_ROW\">Add Row</span>\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/gantt-chart/dialogs/add-edit/views/row-form-view.html\'\"></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"GANTT.ADD_TASK\">Add Task</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/gantt-chart/dialogs/add-edit/views/task-form-view.html\'\"></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gantt-chart/dialogs/add-edit/edit-dialog.html","<md-dialog class=\"gantt-chart-add-edit-dialog\" aria-label=\"Edit Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Edit</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll ng-if=\"vm.formView === \'row\'\" ng-include=\"\'app/main/gantt-chart/dialogs/add-edit/views/row-form-view.html\'\">\n</md-dialog-content><md-dialog-content ms-scroll ng-if=\"vm.formView === \'task\'\" \nng-include=\"\'app/main/gantt-chart/dialogs/activity/activity.html\'\"></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gantt-chart/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><h2><span>Settings</span></h2></div>\n</md-toolbar><md-content class=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"GANTT.EDIT\">Edit</span></md-subheader><md-list-item><md-icon md-font-icon=\"icon-pencil\"></md-icon><p \ntranslate=\"GANTT.DRAW\">Draw</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.draw\"></md-checkbox>\n</md-list-item><md-list-item><md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.READ_ONLY\">Read only</p>\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.options.readOnly\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SNAP\">Snap</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-magnet\"></md-icon><p translate=\"GANTT.SNAP_AREA\">Snap area</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.columnMagnet\" placeholder=\"Snap area\"><md-option value=\"column\" \ntranslate=\"GANTT.COLUMN\">Column</md-option><md-option value=\"1 second\" translate=\"GANTT.1_SECOND\">1 second</md-option>\n<md-option value=\"1 minute\" translate=\"GANTT.1_MINUTE\">1 minute</md-option><md-option value=\"5 minutes\" \ntranslate=\"GANTT.5_MINUTES\">5 minutes</md-option><md-option value=\"15 minutes\" translate=\"GANTT.15_MINUTES\">15 minutes\n</md-option><md-option value=\"1 hour\" translate=\"GANTT.1_HOUR\">1 hour</md-option><md-option value=\"1 day\" \ntranslate=\"GANTT.1_DAY\">1 day</md-option><md-option value=\"5 days\" translate=\"GANTT.5_DAYS\">5 days</md-option>\n</md-select></md-list-item><md-list-item><md-icon md-font-icon=\"icon-view-day\"></md-icon><p translate=\"GANTT.DAILY\">\nDaily</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.daily\"></md-checkbox></md-list-item><md-list-item>\n<md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.TIME_FRAMES\">Time frames</p><md-checkbox \nclass=\"md-secondary\" ng-model=\"vm.options.timeFramesMagnet\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SIDEBAR\">Sidebar</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><p translate=\"GANTT.SHOW_SIDEBAR\">Show Sidebar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.labelsEnabled\"></md-checkbox></md-list-item><md-list-item><md-icon md-font-icon=\"icon-code-tags\">\n</md-icon><p translate=\"GANTT.RESIZABLE\">Resizable</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.allowSideResizing\"></md-checkbox></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.LIST_MODE\">List Mode</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.sideMode\" placeholder=\"List\"><md-option value=\"Tree\" \ntranslate=\"GANTT.TREE\">Tree</md-option><md-option value=\"Table\" translate=\"GANTT.TABLE\">Table</md-option><md-option \nvalue=\"TreeTable\" translate=\"GANTT.TREE_TABLE\">TreeTable</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"GANTT.TIMELINE\">Timeline</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.GROUPS\">Groups</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.groupDisplayMode\" placeholder=\"Groups\"><md-option value=\"group\" \ntranslate=\"GANTT.GROUP\">Group</md-option><md-option value=\"overview\" translate=\"GANTT.OVERVIEW\">Overview</md-option>\n<md-option value=\"promote\" translate=\"GANTT.PROMOTE\">Promote</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-list-item>\n<md-icon md-font-icon=\"icon-calendar-today\"></md-icon><p translate=\"GANTT.TODAY\">Today</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.currentDate\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"line\" translate=\"GANTT.LINE\">Line</md-option><md-option \nvalue=\"column\" translate=\"GANTT.COLUMN\">Column</md-option></md-select></md-list-item><md-divider></md-divider>\n<md-list-item><md-icon md-font-icon=\"icon-arrow-expand\"></md-icon><p translate=\"GANTT.EXPAND\">Expand</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.autoExpand\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"both\" translate=\"GANTT.BOTH\">Both</md-option><md-option \nvalue=\"left\" translate=\"GANTT.LEFT\">Left</md-option><md-option value=\"right\" translate=\"GANTT.RIGHT\">Right</md-option>\n</md-select></md-list-item><md-divider></md-divider><md-list-item><md-icon md-font-icon=\"icon-content-cut\"></md-icon><p\n translate=\"GANTT.OUT_OF_RANGE\">Out of range</p><md-select class=\"simplified md-secondary\" \nng-model=\"vm.options.taskOutOfRange\" placeholder=\"Out of range\"><md-option value=\"expand\" translate=\"GANTT.EXPAND\">\nEXPAND</md-option><md-option value=\"truncate\" translate=\"GANTT.TRUNCATE\">Truncate</md-option></md-select>\n</md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/main/time-schedule-settings/sidenavs/left/left-sidenav.html","<div class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/time-schedule-settings/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex>\n</div>");
$templateCache.put("app/main/time-schedule-settings/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/apps/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/main/user-settings/sidenavs/left/left-sidenav.html","<div class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/user-settings/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/user-settings/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/apps/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/gantt-chart/dialogs/activity/dialogs/add.activity.html","");
$templateCache.put("app/main/gantt-chart/dialogs/add-edit/views/row-form-view.html","<div class=\"row\" layout=\"column\"><form name=\"rowForm\" ng-submit=\"vm.dialogType === \'add\'?vm.addNewRow():vm.saveRow();\">\n<div class=\"form-content\"><div layout=\"row\"><div flex class=\"input-block\"><md-input-container flex class=\"row-name\">\n<label>Row Name</label><input name=\"name\" ng-model=\"vm.row.name\" required></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label>Parent Row:</label><md-select ng-model=\"vm.row.parent\"><md-option value=\"\">No Parent</md-option><md-option \nng-repeat=\"row in vm.chartData\" ng-value=\"row.id\">{{row.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>Sortable:</label><md-switch \nng-model=\"vm.row.sortable\" aria-label=\"Sortable\"></md-switch></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start center\"><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>\nRow Color:</label><ms-material-color-picker ng-model=\"vm.row.classes[1]\"></ms-material-color-picker></div><div flex \nclass=\"input-block\"><md-input-container flex layout=\"row\" layout-align=\"space-between center\"><label>Extra Class\n</label><input name=\"name\" ng-model=\"vm.row.classes[0]\"></md-input-container></div></div></div><md-dialog-actions>\n<md-button ng-if=\"vm.dialogType === \'edit\'\" class=\"md-icon-button\" ng-click=\"vm.removeRow()\" aria-label=\"Remove\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-disabled=\"rowForm.$invalid || rowForm.$pristine\" aria-label=\"Save\"><span ng-if=\"vm.dialogType === \'add\'\">Add</span> \n<span ng-if=\"vm.dialogType === \'edit\'\">Save</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/gantt-chart/dialogs/add-edit/views/task-form-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\" \nng-submit=\"vm.dialogType === \'add\'?vm.addNewTask():vm.saveTask();\"><div class=\"form-content\"><div layout=\"row\"><div \nflex class=\"input-block\"><md-input-container flex class=\"task-name\"><label>Activity Number</label><input \ndisabled=\"disabled\" name=\"name\" ng-model=\"vm.task.name\" required></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex layout=\"row\" \nlayout-align=\"space-between center\"><label>Start Date/Time:</label><sm-date-time-picker fname=\"tfrom\" lable=\"\" \nform=\"taskForm\" value=\"vm.task.from\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" is-required=\"{{true}}\" \nformat=\"MM-DD-YYYY HH:mm\" mode=\"date-time\" week-start-day=\"Sunday\"></sm-date-time-picker></div><div \nclass=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>Duration:</label><input type=\"number\" \nng-model=\"vm.task.duration\"></div></div><div ng-if=\"vm.dialogType === \'add\'\" layout=\"row\" layout-align=\"start start\">\n<div flex class=\"input-block\"><md-input-container><label>Row:</label><md-select name=\"rowId\" ng-model=\"vm.taskRowId\" \nrequired><md-option ng-repeat=\"row in vm.chartData\" ng-value=\"row.id\">{{row.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start center\" class=\"input-block\"><label flex=\"25\">\nProgress: <small>{{vm.task.progress}}</small></label><md-slider flex ng-model=\"vm.task.progress\" step=\"1\" min=\"0\" \nmax=\"100\" aria-label=\"Progress\"></md-slider></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\">\n<div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>Task Color:</label>\n<ms-material-color-picker ng-model=\"vm.task.classes[1]\"></ms-material-color-picker></div><div flex class=\"input-block\">\n<md-input-container flex layout=\"row\" layout-align=\"space-between center\"><label>Extra Class</label><input name=\"name\" \nng-model=\"vm.task.classes[0]\"></md-input-container></div></div></div><md-dialog-actions><md-button \nng-if=\"vm.dialogType === \'edit\'\" class=\"md-icon-button\" ng-click=\"vm.removeTask()\" aria-label=\"Remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Save\"><span ng-if=\"vm.dialogType === \'add\'\">Add\n</span> <span ng-if=\"vm.dialogType === \'edit\'\">Save</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/time-schedule-settings/sidenavs/left/views/chats/chats-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div class=\"avatar-wrapper\"><img \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" ng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar\" \nalt=\"{{vm.user.name}}\"><md-menu id=\"user-status-menu\"><i ng-click=\"$mdOpenMenu()\" class=\"icon icon- s16 status\" \nng-class=\"vm.user.status\"></i><md-menu-content><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'online\')\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon s16 status icon-checkbox-marked-circle mr-8 green-fg\"></i> \n<span translate=\"CHAT.STATUS_ONLINE\">Online</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'away\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-clock mr-8 yellow-fg\"></i> <span translate=\"CHAT.STATUS_AWAY\">Away</span></div></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'do-not-disturb\')\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 status icon-minus-circle mr-8 red-fg\"></i> <span \ntranslate=\"CHAT.STATUS_DO_NOT_DISTURB\">Do not disturb</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'offline\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-checkbox-blank-circle-outline mr-8 green-fg\"></i> <span translate=\"CHAT.STATUS_OFFLINE\">\nOffline</span></div></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nmd-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" translate=\"CHAT.PROFILE\">Profile</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"\" translate=\"CHAT.LOGOUT\">Logout</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.chatSearch\" type=\"text\" \nplaceholder=\"Search or start new chat\" translate=\"\" translate-attr-placeholder=\"CHAT.CHAT_SEARCH_PLACEHOLDER\"></div>\n</div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"chat-list\"><div \nng-show=\"vm.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length + filteredContact.length }\" \ntranslate=\"CHAT.CHATS\">CHATS</div><md-list-item class=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:{}} | filter: {name: vm.chatSearch}  |  orderBy: \'lastMessage.time\' :true | filter:query as filteredChat\" \nng-click=\"vm.getChat(contact.id)\" ng-class=\"{\'unread\':contact.unread}\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3 class=\"name\">{{contact.name}}</h3><p \nclass=\"last-message text-truncate\">{{contact.lastMessage.message}}</p></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"last-message-time\">{{contact.lastMessage.time | altDate}}</div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div></div><md-divider>\n</md-divider></md-list-item></md-list><md-list class=\"contact-list\"><div \nng-show=\"vm.chatSearch && filteredContact.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}\" \ntranslate=\"CHAT.CONTACTS\">CONTACTS</div><md-list-item class=\"contact md-3-line\" ng-show=\"vm.chatSearch\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:null} | filter: {name: vm.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div>\n<div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"mood\">{{contact.mood}}</p></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide=\"(filteredChat.length + filteredContact.length) > 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content><md-button \nclass=\"md-fab contacts-button\" ng-click=\"vm.toggleLeftSidenavView(\'contacts\')\" aria-label=\"contacts button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/time-schedule-settings/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><h3><span>Time Schedules\n</span></h3></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.scheduleSearch\" type=\"text\" \nplaceholder=\"Search time schedules\"></div></div></div></md-toolbar><md-content flex ms-scroll><md-list \nclass=\"contact-list\"><md-list-item class=\"contact md-3-line\" \nng-repeat=\"schedule in vm.timeSchedules  | filter: {Name: vm.scheduleSearch} | orderBy: \'Name\' :false | filter:query as filteredSchedule\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredSchedule.length - $index}\" \nng-click=\"vm.loadSchedule(schedule)\"><div class=\"avatar-wrapper\"><i class=\"icon icon-alarm s30\" \nstyle=\"margin-right:10px\"></i></div><div class=\"md-list-item-text\"><h3>{{schedule.Name}}</h3></div></md-list-item>\n</md-list><div ng-if=\"filteredSchedule.length <= 0\" class=\"no-results-message\">No results..</div></md-content>\n<md-button class=\"md-fab contacts-button\" ng-click=\"vm.addNewSchedule()\" aria-label=\"contacts button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/time-schedule-settings/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar user-avatar huge\" alt=\"{{vm.user.name}}\"><div class=\"user-name\">\n{{vm.user.name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll ms-padding><md-card>\n<md-card-title>Mood</md-card-title><md-card-content><span class=\"mood\" editable-textarea=\"vm.user.mood\" e-rows=\"7\" \ne-cols=\"40\">{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/time-schedule-settings/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"><div class=\"contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex \nms-scroll ms-padding><md-card><md-card-title translate=\"CHAT.MOOD\">Mood</md-card-title><md-card-content><span \nclass=\"mood\" ng-if=\"vm.contacts.getById(vm.chatContactId).mood\">{{vm.contacts.getById(vm.chatContactId).mood}}</span>\n</md-card-content></md-card></md-content>");
$templateCache.put("app/main/user-settings/sidenavs/left/views/chats/chats-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div class=\"avatar-wrapper\"><img \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" ng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar\" \nalt=\"{{vm.user.name}}\"><md-menu id=\"user-status-menu\"><i ng-click=\"$mdOpenMenu()\" class=\"icon icon- s16 status\" \nng-class=\"vm.user.status\"></i><md-menu-content><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'online\')\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon s16 status icon-checkbox-marked-circle mr-8 green-fg\"></i> \n<span translate=\"CHAT.STATUS_ONLINE\">Online</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'away\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-clock mr-8 yellow-fg\"></i> <span translate=\"CHAT.STATUS_AWAY\">Away</span></div></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'do-not-disturb\')\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 status icon-minus-circle mr-8 red-fg\"></i> <span \ntranslate=\"CHAT.STATUS_DO_NOT_DISTURB\">Do not disturb</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'offline\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-checkbox-blank-circle-outline mr-8 green-fg\"></i> <span translate=\"CHAT.STATUS_OFFLINE\">\nOffline</span></div></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nmd-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" translate=\"CHAT.PROFILE\">Profile</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"\" translate=\"CHAT.LOGOUT\">Logout</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.chatSearch\" type=\"text\" \nplaceholder=\"Search or start new chat\" translate=\"\" translate-attr-placeholder=\"CHAT.CHAT_SEARCH_PLACEHOLDER\"></div>\n</div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"chat-list\"><div \nng-show=\"vm.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length + filteredContact.length }\" \ntranslate=\"CHAT.CHATS\">CHATS</div><md-list-item class=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:{}} | filter: {name: vm.chatSearch}  |  orderBy: \'lastMessage.time\' :true | filter:query as filteredChat\" \nng-click=\"vm.getChat(contact.id)\" ng-class=\"{\'unread\':contact.unread}\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3 class=\"name\">{{contact.name}}</h3><p \nclass=\"last-message text-truncate\">{{contact.lastMessage.message}}</p></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"last-message-time\">{{contact.lastMessage.time | altDate}}</div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div></div><md-divider>\n</md-divider></md-list-item></md-list><md-list class=\"contact-list\"><div \nng-show=\"vm.chatSearch && filteredContact.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}\" \ntranslate=\"CHAT.CONTACTS\">CONTACTS</div><md-list-item class=\"contact md-3-line\" ng-show=\"vm.chatSearch\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:null} | filter: {name: vm.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div>\n<div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"mood\">{{contact.mood}}</p></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide=\"(filteredChat.length + filteredContact.length) > 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content><md-button \nclass=\"md-fab contacts-button\" ng-click=\"vm.toggleLeftSidenavView(\'contacts\')\" aria-label=\"contacts button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/user-settings/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar user-avatar huge\" alt=\"{{vm.user.name}}\"><div class=\"user-name\">\n{{vm.user.name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll ms-padding><md-card>\n<md-card-title>Mood</md-card-title><md-card-content><span class=\"mood\" editable-textarea=\"vm.user.mood\" e-rows=\"7\" \ne-cols=\"40\">{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/user-settings/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><h3><span>Users</span></h3>\n</div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.contactSearch\" type=\"text\" \nplaceholder=\"Search users\"></div></div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"contact-list\">\n<md-list-item class=\"contact md-3-line\" \nng-repeat=\"contact in vm.contacts  | filter: {FirstName: vm.contactSearch} | orderBy: \'FirstName\' :false | filter:query as filteredContact\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-click=\"vm.loadUser(contact)\"><div class=\"avatar-wrapper\"><img src=\"assets/images/avatars/profile.jpg\" \nclass=\"md-avatar avatar\" alt=\"{{contact.FirstName + \' \' + contact.LastName }}\"> <i class=\"icon icon- s16 status\" \nng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3>{{contact.FirstName + \' \' + contact.LastName }}\n</h3><p class=\"mood\">{{contact.mood}}</p></div></md-list-item></md-list><div ng-if=\"filteredContact.length <= 0\" \nclass=\"no-results-message\">No results..</div></md-content><md-button class=\"md-fab contacts-button\" \nng-click=\"vm.addNewUser()\" aria-label=\"contacts button\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/user-settings/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"><div class=\"contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex \nms-scroll ms-padding><md-card><md-card-title translate=\"CHAT.MOOD\">Mood</md-card-title><md-card-content><span \nclass=\"mood\" ng-if=\"vm.contacts.getById(vm.chatContactId).mood\">{{vm.contacts.getById(vm.chatContactId).mood}}</span>\n</md-card-content></md-card></md-content>");}]);